// Booking actions follow the persisted lifecycle: a session attached to a visit
// can be started, which changes it to In Progress; only an In Progress session
// can then be completed. The schedule cell displays time as the primary value
// and date below it without changing the underlying date/time data.
// import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react';
// import { useHistory } from 'react-router-dom';
// import { Plus, Search, Filter, Edit2, CheckCircle, XCircle, X, AlertTriangle, MessageSquare, UserCheck, LogIn } from 'lucide-react';
// import toast from 'react-hot-toast';
// import { format } from 'date-fns';
// import './styles/appointments.css';

// import { AgGridReact } from "ag-grid-react";
// import "ag-grid-community/dist/styles/ag-grid.css";
// import "ag-grid-community/dist/styles/ag-theme-balham.css";
// import Button from './ui/Button';
// import Badge, { statusVariant } from './ui/Badge';
// import bookingplanService from '../../core/services/bookingplanService';
// import { apiFetch } from '../../shared/helper/apiFetch';
// import doctorServices from '../../core/services/doctorServices';
// import roomServices from '../../core/services/roomServices';
// import { useDispatch } from 'react-redux';
// import { patientActions } from '../../core/actions';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';

// const getPlanAssignment = (plan) => {
//   const hasDoctor = Boolean(
//     plan.doctor_id || plan.counselor || plan.doctor_name || plan.counselor_name || plan.doctor_identifier || plan.doctor_type || plan.first_name
//   );
//   const hasRoom = Boolean(plan.room_id || plan.room_number);
//   return { hasDoctor, hasRoom };
// };

// const defaultColDef = {
//   editable: false,
//   sortable: true,
//   flex: 1,
//   minWidth: 100,
//   filter: true, // Disable all column filters - using advanced filter panel
//   resizable: true,
//   floatingFilter: true, // Disable floating filters
// };

// const getRowClass = (plan) => {
//   const { hasDoctor, hasRoom } = getPlanAssignment(plan);
//   if (!hasDoctor && !hasRoom) return 'row-unassigned';
//   if (!hasDoctor || !hasRoom) return 'row-partial';
//   return '';
// };

// const normalizeApiList = (response) => {
//   if (!response) return [];
//   if (Array.isArray(response?.data?.data)) return response.data.data;
//   if (Array.isArray(response?.accresp?.personList)) return response.accresp.personList;
//   if (Array.isArray(response?.roomList)) return response.roomList;
//   if (Array.isArray(response?.personList)) return response.personList;
//   if (Array.isArray(response?.data)) return response.data;
//   if (Array.isArray(response)) return response;
//   return [];
// };

// const getDoctorDisplayName = (doctor) => {
//   if (!doctor) return 'Unassigned';
//   if (doctor.label) return doctor.label;
//   if (doctor.doctor_name) return doctor.doctor_name;
//   if (doctor.name || doctor.fullName) {
//     const title = doctor.displaytitle || doctor.title || doctor.degree || '';
//     const name = [doctor.first_name, doctor.mname, doctor.last_name, doctor.name, doctor.fullName]
//       .filter(Boolean).join(' ').trim();
//     if (title && name) return `${title} ${name}`;
//     if (name) return name;
//   }
//   if (doctor.doctor_identifier || doctor.identifier) {
//     return [doctor.doctor_identifier || doctor.identifier, doctor.doctor_type || doctor.type]
//       .filter(Boolean)
//       .join(' - ');
//   }
//   if (doctor.displayName) return doctor.displayName;
//   return [doctor.displaytitle || doctor.title || doctor.degree || '']
//     .concat([doctor.first_name, doctor.mname, doctor.last_name].filter(Boolean))
//     .filter(Boolean)
//     .join(' ') || 'Unassigned';
// };

// const getRoomDisplayName = (room) => {
//   if (!room) return 'No Room';
//   const code = room.roomCode || room.room_code || room.code || room.roomNo || room.room_number || '';
//   const name = room.roomName || room.room_name || room.room_number || room.roomNumber || room.roomname || room.name || room.title || room.label || '';
//   if (code && name) return `${code} - ${name}`;
//   return name || code || room.label || 'Room';
// };
// // -- time formatting helpers --------------------------------
// const formatTime12h = (timeStr) => {
//   if (!timeStr) return null;
//   const match = String(timeStr).match(/(\d{1,2}):(\d{2})(?::(\d{2}))?/);
//   if (!match) return timeStr;
//   let hours = parseInt(match[1], 10);
//   const minutes = match[2];
//   const period = hours >= 12 ? 'PM' : 'AM';
//   hours = hours % 12;
//   if (hours === 0) hours = 12;
//   return `${hours}:${minutes} ${period}`;
// };

// const formatDateTime12h = (dateTimeStr) => {
//   if (!dateTimeStr) return null;
//   const str = String(dateTimeStr);
//   const sepIdx = str.indexOf(' ') !== -1 ? str.indexOf(' ') : str.indexOf('T');
//   if (sepIdx === -1) return formatTime12h(str); // it's just a bare time, no date part
//   const datePart = str.slice(0, sepIdx);
//   const timePart = str.slice(sepIdx + 1);
//   const formattedTime = formatTime12h(timePart);
//   return formattedTime ? `${datePart} ${formattedTime}` : str;
// };

// // -- Modal Components ---------------------------------------

// const ModalOverlay = ({ children, onClose }) => (
//   <div style={{
//     position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
//     background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center',
//     justifyContent: 'center', zIndex: 9999,
//   }} onClick={onClose}>
//     <div style={{
//       background: '#fff', borderRadius: 12, padding: 24, width: 480,
//       maxWidth: '90vw', boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
//     }} onClick={(e) => e.stopPropagation()}>
//       {children}
//     </div>
//   </div>
// );

// const BoardPatientModal = ({ bookingId, bookingCode, patientName, patientId, visitId, onClose, onSuccess }) => {
//   const [submitting, setSubmitting] = useState(false);
//   const [selectedRadio, setSelectedRadio] = useState("OutPatient");
//   const [selecteddate, setSelecteddate] = useState(new Date().toISOString().split('T')[0]);
//   const [selectedTime, setSelectedTime] = useState(format(new Date(), "HH:mm"));

//   const handleBoard = async () => {
//     try {
//       setSubmitting(true);
//         const hasSpecialVisitFlag =
//           selectedRadio === "Walkin" || selectedRadio === "Proxy";
//         const boardingPayload = {
//           type:
//             selectedRadio === "Walkin"
//               ? "InPatient"
//               : selectedRadio === "Proxy"
//                 ? "OutPatient"
//                 : selectedRadio,
//           visitFlag: hasSpecialVisitFlag ? selectedRadio : null,
//           admissionDate:
//             selectedRadio === "InPatient" || selectedRadio === "Walkin"
//               ? `${selecteddate} ${selectedTime}:00`
//               : "",
//         };
//         const result = await bookingplanService.boardPatient(bookingId, boardingPayload);
      
//       if (result) {
//         toast.success('? Patient boarded successfully');
//         // Pass bookingId and the new visitId from the response
//         const newVisitId = result?.data?.visit_id || result?.visit_id || visitId;
//         onSuccess(bookingId, newVisitId);
//         onClose();
//       }
//     } catch (err) {
//       console.error(err);
//       const rawMsg = err?.message || err?.data?.message || '';
//       const cleanMsg = rawMsg
//         .replace(/^Error[:\s]*/i, '')
//         .replace(/^Failed to board patient[:\s]*/i, '')
//         .trim();
//       const msg = cleanMsg ? `Error: Cannot board patient. ${cleanMsg}` : 'Error: Cannot board patient. Please try again.';
//       toast.error(msg);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Dialog
//       open={true}
//       onClose={onClose}
//       className="d-flex w-95 h-90 flex-column-reverse dialog"
//       maxWidth="sm"
//       fullWidth
//     >
//       <div>
//         <DialogTitle>
//           Select Patient Category
//           <IconButton
//             aria-label="close"
//             onClick={onClose}
//             sx={{
//               position: 'absolute',
//               right: 8,
//               top: 8,
//               color: (theme) => theme.palette.grey[500],
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent style={{ padding: '0px 24px' }}>
//           <span>Are you sure to OnBoard a patient?</span>
//         </DialogContent>
//         <DialogActions
//           className="d-flex flex-column align-items-end"
//           style={{ paddingTop: '0px' }}
//         >
//           <RadioGroup
//             row
//             aria-label="patientCategory"
//             name="patientCategory"
//             value={selectedRadio}
//             onChange={(e) => setSelectedRadio(e.target.value)}
//             className="d-flex w-100 justify-content-between"
//           >
//             <FormControlLabel
//               value="InPatient"
//               control={<Radio />}
//               label="InPatient"
//             />
//             <FormControlLabel
//               value="OutPatient"
//               control={<Radio />}
//               label="OutPatient"
//             />
//             <FormControlLabel
//               value="Walkin"
//               control={<Radio />}
//               label="Walk In"
//             />
//             <FormControlLabel
//               value="Proxy"
//               control={<Radio />}
//               label="Proxy"
//             />
      
//           </RadioGroup>
//           {selectedRadio === "InPatient" ||
//           selectedRadio === "Walkin" ? (
//             <div
//               className="d-flex justify-content-end"
//               style={{
//                 flexDirection: 'column',
//                 padding: '0px 10px',
//                 marginRight: 'auto',
//               }}
//             >
//               <label style={{ paddingTop: '5px', paddingBottom: '20px' }}>
//                 Select a Admission Date:
//               </label>
//               <div style={{ display: 'flex', gap: 12, marginTop: 12, padding: 16, background: '#f8fafc', borderRadius: 8 }}>
//                 <div style={{ flex: 1 }}>
//                   <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 6, color: '#475569' }}>
//                     Select an Admission Date:
//                   </label>
//                   <input
//                     type="date"
//                     value={selecteddate}
//                     onChange={(e) => setSelecteddate(e.target.value)}
//                     style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }}
//                   />
//                 </div>
//                 <div style={{ flex: 1 }}>
//                   <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 6, color: '#475569' }}>
//                     Select an Admission Time:
//                   </label>
//                   <input
//                     type="time"
//                     value={selectedTime}
//                     onChange={(e) => setSelectedTime(e.target.value)}
//                     style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }}
//                   />
//                 </div>
//               </div>
//             </div>
//           ) : (
//             ""
//           )}
//           <Button
//             variant="contained"
//             color="primary"
//             className="btn-style bottomright mt-2"
//             onClick={handleBoard}
//             disabled={submitting}
//             style={{ textTransform: 'none', marginRight: '15px' }}
//           >
//             {submitting ? 'Boarding...' : 'Save'}
//           </Button>
//         </DialogActions>
//       </div>
//     </Dialog>
//   );
// };

// const CompleteBookingModal = ({ bookingId, bookingCode, patientName, onClose, onSuccess }) => {
//   const [comments, setComments] = useState('');
//   const [submitting, setSubmitting] = useState(false);

//   const handleComplete = async () => {
//     try {
//       setSubmitting(true);
//       await bookingplanService.markBookingComplete(bookingId);
//       toast.success('✅  Booking completed successfully');
//       onSuccess();
//       onClose();
//     } catch (err) {
//       console.error(err);
//       const rawMsg = err?.message || err?.data?.message || '';
//       const cleanMsg = rawMsg
//         .replace(/^Error[:\s]*/i, '')
//         .replace(/^Failed to complete booking[:\s]*/i, '')
//         .trim();
//       const msg = cleanMsg ? `Error: Cannot complete booking. ${cleanMsg}` : 'Error: Cannot complete booking. Please try again.';
//       toast.error(msg);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <ModalOverlay onClose={onClose}>
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
//         <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
//           <CheckCircle size={20} color="#16a34a" /> Complete Booking
//         </h3>
//         <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}>
//           <X size={20} />
//         </button>
//       </div>
//       <div style={{
//         background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 8,
//         padding: '12px 16px', marginBottom: 16, fontSize: 14, color: '#0c4a6e',
//       }}>
//         Are you sure to complete booking for patient <strong>{patientName || 'N/A'}</strong>?
//       </div>
//       {/* <p style={{ color: '#475569', marginBottom: 16, fontSize: 14 }}>
//         Complete booking <strong>{bookingCode || `#${bookingId}`}</strong> and add any relevant notes.
//       </p> */}
//       <div style={{ marginBottom: 20 }}>
//         <label style={{ display: 'block', fontWeight: 600, marginBottom: 6, fontSize: 14, color: '#334155' }}>
//           Comments / Notes
//         </label>
//         <textarea
//           value={comments}
//           onChange={(e) => setComments(e.target.value)}
//           placeholder="Enter completion notes (optional)..."
//           rows={4}
//           style={{
//             width: '100%', padding: '10px 12px', border: '1px solid #d1d5db',
//             borderRadius: 8, fontSize: 14, resize: 'vertical', boxSizing: 'border-box',
//             fontFamily: 'inherit',
//           }}
//         />
//       </div>
//       <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
//         <Button variant="secondary" onClick={onClose} disabled={submitting}>Cancel</Button>
//         <Button variant="primary" onClick={handleComplete} disabled={submitting}>
//           {submitting ? 'Completing...' : 'Confirm Complete'}
//         </Button>
//       </div>
//     </ModalOverlay>
//   );
// };

// const CancelBookingModal = ({ bookingId, bookingCode, patientName, onClose, onSuccess }) => {
//   const [cancelReason, setCancelReason] = useState('');
//   const [submitting, setSubmitting] = useState(false);

//   const handleCancel = async () => {
//     try {
//       setSubmitting(true);
//       await bookingplanService.updateBookingPlanStatusWithComments(bookingId, 'Cancelled', cancelReason);
//       toast.success('✅ Booking cancelled successfully');
//       onSuccess();
//       onClose();
//     } catch (err) {
//       console.error(err);
//       const rawMsg = err?.message || err?.data?.message || '';
//       const cleanMsg = rawMsg
//         .replace(/^Error[:\s]*/i, '')
//         .replace(/^Failed to cancel booking[:\s]*/i, '')
//         .trim();
//       const msg = cleanMsg ? `Error: Cannot cancel booking. ${cleanMsg}` : 'Error: Cannot cancel booking. Please try again.';
//       toast.error(msg);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <ModalOverlay onClose={onClose}>
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
//         <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
//           <AlertTriangle size={20} color="#dc2626" /> Cancel Booking Plan
//         </h3>
//         <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}>
//           <X size={20} />
//         </button>
//       </div>
//       {/* <div style={{
//         background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8,
//         padding: '12px 16px', marginBottom: 16, fontSize: 14, color: '#991b1b',
//       }}>
//         <strong>Warning:</strong> Cancelling this booking will:
//         <ul style={{ margin: '8px 0 0', paddingLeft: 20 }}>
//           <li>Mark the booking as Cancelled</li>
//           <li>Record cancellation date and time</li>
//           <li>Remove the corresponding room status record</li>
//           <li>Free up the assigned room</li>
//         </ul>
//       </div> */}
//       <div style={{
//         background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 8,
//         padding: '12px 16px', marginBottom: 16, fontSize: 14, color: '#0c4a6e',
//       }}>
//         Are you sure to cancel booking for patient <strong>{patientName || 'N/A'}</strong>?
//       </div>
//       <p style={{ color: '#475569', marginBottom: 16, fontSize: 14 }}>
//         Cancel booking <strong>{bookingCode || `#${bookingId}`}</strong>?
//       </p>
//       <div style={{ marginBottom: 20 }}>
//         <label style={{ display: 'block', fontWeight: 600, marginBottom: 6, fontSize: 14, color: '#334155' }}>
//           <MessageSquare size={14} style={{ marginRight: 4 }} /> Cancel Reason
//         </label>
//         <textarea
//           value={cancelReason}
//           onChange={(e) => setCancelReason(e.target.value)}
//           placeholder="Enter reason for cancellation (optional)..."
//           rows={3}
//           style={{
//             width: '100%', padding: '10px 12px', border: '1px solid #d1d5db',
//             borderRadius: 8, fontSize: 14, resize: 'vertical', boxSizing: 'border-box',
//             fontFamily: 'inherit',
//           }}
//         />
//       </div>
//       <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
//         <Button variant="secondary" onClick={onClose} disabled={submitting}>Keep Booking</Button>
//         <Button
//           variant="danger"
//           onClick={handleCancel}
//           disabled={submitting}
//           style={{ background: '#dc2626', color: '#fff', border: 'none' }}
//         >
//           {submitting ? 'Cancelling...' : 'Confirm Cancel'}
//         </Button>
//       </div>
//     </ModalOverlay>
//   );
// };

// export default function BookingPlans() {
//   const history = useHistory();
//   const gridRef = useRef(null);
//   const dispatch = useDispatch();

//   // Callback to save inline cell edits to the backend
//   const handleCellValueChanged = useCallback(async (event) => {
//     const { data, colDef, newValue, oldValue } = event;
//     if (newValue === oldValue) return;
//     if (!data?.id) return;

//     const field = colDef.field;
//     // Only handle fields that can be updated via simple cell edit
//     const allowedFields = ['medicine_oil', 'notes', 'session_number', 'total_sessions'];
//     if (!allowedFields.includes(field)) return;

//     try {
//       // Build a minimal update payload with the changed field
//       const updatePayload = { id: data.id };
//       updatePayload[field] = newValue;

//       // Include other key fields to prevent data loss
//       if (data.doctor_id) updatePayload.doctor_id = data.doctor_id;
//       if (data.room_id) updatePayload.room_id = data.room_id;
      
//       await bookingplanService.updateBookingPlan(data.id, updatePayload);
//       toast.success(`✅ ${colDef.headerName || field} updated`);
//     } catch (err) {
//       console.error('Failed to update cell:', err);
//       toast.error(`Failed to update ${colDef.headerName || field}`);
//       // Revert the cell to its previous value
//       event.api.stopEditing();
//       event.node.setDataValue(field, oldValue);
//     }
//   }, []);

//   const [filters, setFilters] = useState({
//     search: '',
//     status: '',
//     date_from: '',
//     date_to: '',
//     doctor_id: '',
//     room_id: '',
//   });

//   const [doctors, setDoctors] = useState([]);
//   const [rooms, setRooms] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showFilters, setShowFilters] = useState(false);
//   const [loadingDropdowns, setLoadingDropdowns] = useState(true);
//   const [columnFiltersActive, setColumnFiltersActive] = useState(false);

//   const getRoomLookupId = (room) =>
//     room?.id || room?.room_id || room?.roomId || room?.roomNumber || room?.room_number || room?.code || room?.roomCode || '';

//   // Modal states
//   const [boardModal, setBoardModal] = useState({ open: false, id: null, code: null, patientName: null, patientId: null });
//   const [completeModal, setCompleteModal] = useState({ open: false, id: null, code: null, patientName: null });
//   const [cancelModal, setCancelModal] = useState({ open: false, id: null, code: null, patientName: null });

//   // Pagination states matching Ag-Grid's internal pagination indicators
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [currentPage, setCurrentPage] = useState(0);
//   const currentPageRef = useRef(0);
//   const [debouncedSearch, setDebouncedSearch] = useState('');

//   // The 630px grid fits seven 70px booking rows plus its header and pager.
//   // Keep this shared by the infinite-row cache, API limit, and pagination.
//   const DEFAULT_PAGE_SIZE = 7;
//   const gridApiRef = useRef(null);

//   // Dynamically calculate the records display string tracking variables 
//   const startRecord = totalRecords > 0 ? currentPage * DEFAULT_PAGE_SIZE + 1 : 0;
//   const endRecord = totalRecords > 0 ? Math.min(startRecord + DEFAULT_PAGE_SIZE - 1, totalRecords) : 0;

//   useEffect(() => {
//     fetchDoctorsAndRooms();
//   }, []); // eslint-disable-line react-hooks/exhaustive-deps

//   useEffect(() => {
//     const timer = setTimeout(() => setDebouncedSearch(filters.search), 350);
//     return () => clearTimeout(timer);
//   }, [filters.search]);

//   const appliedFilters = useMemo(() => ({
//     search: debouncedSearch,
//     status: filters.status,
//     date_from: filters.date_from,
//     date_to: filters.date_to,
//     doctor_id: filters.doctor_id,
//     room_id: filters.room_id,
//   }), [debouncedSearch, filters.status, filters.date_from, filters.date_to,
//     filters.doctor_id, filters.room_id]);

//   // This core handler configures a standard source model mapping Ag-Grid pagination triggers to API params
//   const updateDatasource = useCallback((api, currentFilters) => {
//     if (!api) return;

//     const datasource = {
//       getRows: async (params) => {
//         try {
//           setLoading(true);

//           // Ag-Grid's startRow natively calculates your offset (e.g. Page 2 is startRow: 3)
//           const offset = params.startRow;
//           const limit = params.endRow - params.startRow;
//           const calculatedPage = Math.floor(offset / DEFAULT_PAGE_SIZE);

//           const isFilterActive = Boolean(
//             currentFilters.search || currentFilters.status || currentFilters.date_from || currentFilters.date_to ||
//             currentFilters.doctor_id || currentFilters.room_id || Object.keys(params.filterModel || {}).length
//           );
//           const today = new Date().toISOString().split('T')[0];

//           // Extract sortModel from Ag-Grid params (set when user clicks a column header)
//           let sortColumn = '';
//           let sortOrder = isFilterActive ? 'desc' : 'asc';
//           if (params.sortModel && params.sortModel.length > 0) {
//             const sortEntry = params.sortModel[0];
//             sortColumn = sortEntry.colId;
//             sortOrder = sortEntry.sort; // 'asc' or 'desc'
//           }

//           const apiParams = {
//             search: currentFilters.search,
//             status: currentFilters.status,
//             doctor_id: currentFilters.doctor_id,
//             room_id: currentFilters.room_id,
//             date_from: isFilterActive ? currentFilters.date_from : today,
//             date_to: currentFilters.date_to,
//             sort_order: sortOrder,
//             sort_column: sortColumn,
//             offset,
//             limit,
//             main: params.filterModel?.main?.filter,
//             ipopnumber: params.filterModel?.ipopnumber?.filter,
//             patient_name: params.filterModel?.patient_name?.filter,
//             doctor_name: params.filterModel?.doctor_name?.filter,
//             booking_time: params.filterModel?.created_at?.filter,
//             room_number: params.filterModel?.room_number?.filter,
//             booking_date: params.filterModel?.start_date?.filter,
//             column_status: params.filterModel?.status?.filter,
//           };

//           const response = await bookingplanService.getBookingPlans(apiParams);
//           const raw = Array.isArray(response?.data)
//             ? response.data
//             : Array.isArray(response)
//             ? response
//             : response?.data?.data || response?.data?.rows || [];

//           const finalRows = raw.filter((item) => item && typeof item === 'object');
//           const apiTotal = Number(
//             response?.total ??
//             response?.total_records ??
//             response?.data?.total ??
//             response?.data?.total_records ??
//             response?.data?.totalRecords ??
//             response?.totalRecords
//           );

//           const total = Number.isFinite(apiTotal) ? apiTotal : finalRows.length;

//           // Sync React tracking states for your bottom text indicators
//           setTotalRecords(total);
//           setCurrentPage(calculatedPage);
//           currentPageRef.current = calculatedPage;

//           // Send data and total page boundary size directly to Ag-Grid internal mechanism
//           params.successCallback(finalRows, total);
//         } catch (err) {
//           console.error(err);
//           toast.error('Failed to load booking plans');
//           params.failCallback();
//         } finally {
//           setLoading(false);
//         }
//       }
//     };

//     api.setDatasource(datasource);
//   }, []);

//   // Automatically recreates and re-applies the datasource from page 0 whenever filters change
//   useEffect(() => {
//     if (gridApiRef.current) {
//       updateDatasource(gridApiRef.current, appliedFilters);
//     }
//   }, [appliedFilters, updateDatasource]);

//   const fetchDoctorsAndRooms = async () => {
//     try {
//       setLoadingDropdowns(true);
//       const [roomResult, doctorResult, counsellorResult] = await Promise.allSettled([
//         roomServices.getRoomList(),
//         doctorServices.getDoctorListByType('doctor'),
//         doctorServices.getDoctorListByType('counsellor'),
//       ]);

//       let roomResponse = null;
//       if (roomResult.status === 'fulfilled') {
//         roomResponse = roomResult.value;
//         console.log('[BookingPlans] Room API raw response:', roomResponse);
//       } else {
//         console.warn('roomServices.getRoomList failed:', roomResult.reason);
//       }

//       // Combine doctors and counsellors
//       let doctorList = [];
      
//       if (doctorResult.status === 'fulfilled' && doctorResult.value) {
//         const doctors = normalizeApiList(doctorResult.value);
//         console.log('[BookingPlans] Doctors loaded:', doctors.length);
//         doctorList = [...doctorList, ...doctors];
//       } else {
//         console.warn('Failed to load doctors:', doctorResult.reason);
//       }

//       if (counsellorResult.status === 'fulfilled' && counsellorResult.value) {
//         const counsellors = normalizeApiList(counsellorResult.value);
//         console.log('[BookingPlans] Counsellors loaded:', counsellors.length);
//         doctorList = [...doctorList, ...counsellors];
//       } else {
//         console.warn('Failed to load counsellors:', counsellorResult.reason);
//       }

//       // Remove duplicates based on personId
//       const uniqueDoctors = doctorList.filter((doc, index, self) =>
//         index === self.findIndex((d) => d.personId === doc.personId)
//       );

//       const roomList = normalizeApiList(roomResponse);

//       console.log('[BookingPlans] Total unique doctors/counsellors:', uniqueDoctors.length, uniqueDoctors[0] ?? 'empty');
//       console.log('[BookingPlans] Normalized rooms:', roomList.length, roomList[0] ?? 'empty');

//       setDoctors(Array.isArray(uniqueDoctors) ? uniqueDoctors : []);
//       setRooms(Array.isArray(roomList) ? roomList : []);
//     } catch (err) {
//       console.error('Dropdown fetch error:', err);
//     } finally {
//       setLoadingDropdowns(false);
//     }
//   };

//   const getDoctorLookupId = (doctor) => {
//     if (!doctor) return '';
//     return doctor.id || doctor.doctor_id || doctor.doctorId || doctor.personId || doctor.gvid || doctor.gvId || '';
//   };

//   const findDoctorById = (id) => {
//     if (!id) return null;
//     return doctors.find((d) => String(getDoctorLookupId(d)) === String(id)) || null;
//   };

//   const getDoctorNameFromPlan = (plan) => {
//     const id = plan.doctor_id || plan.doctorId || plan.counselor || plan.counselorId;
//     const doctor = findDoctorById(id);
//     if (doctor) return getDoctorDisplayName(doctor);
//     return plan.doctor_name || plan.counselor_name || 'Unassigned';
//   };

//   const getDoctorDepartmentFromPlan = (plan) => {
//     const id = plan.doctor_id || plan.doctorId || plan.counselor || plan.counselorId;
//     const doctor = findDoctorById(id);
//     return doctor?.department || plan.type || plan.specialization || plan.doctor_type || 'No department';
//   };

//   const handleOpenBoardModal = (row) => {
//     setBoardModal({ 
//       open: true, 
//       id: row.id, 
//       code: row.booking_code, 
//       patientName: row.patient_name, 
//       patientId: row.patient_id,
//       visitId: row.visit_id 
//     });
//   };

//   const handleOpenCompleteModal = (row) => {
//     setCompleteModal({ open: true, id: row.id, code: row.booking_code, patientName: row.patient_name });
//   };

//   const handleOpenCancelModal = (row) => {
//     setCancelModal({ open: true, id: row.id, code: row.booking_code, patientName: row.patient_name });
//   };

//   const handleModalSuccess = (bookingId = null, patientId = null, visitId = null) => {
//     // Refresh the grid after status change
//     if (gridApiRef.current) {
//       gridApiRef.current.refreshInfiniteCache();
//     }
    
//     // Navigate to patient page with refresh flag if patientId and visitId are provided (e.g., after boarding)
//     if (patientId && visitId) {
//       // Navigate to patient sections with refresh flag to trigger data refresh
//       history.push({
//         pathname: `/PatientSections/${patientId}/${visitId}`,
//         state: { 
//           refreshRoom: Date.now(), // This triggers the useEffect in PatientSections
//           from: 'booking',
//           returnTo: '/booking-plans'
//         }
//       });
      
//       console.log('[BookingPlans] Navigating to patient page with refresh flag');
//     }
//   };

//   const handleChangeBookingStatus = async (id, status) => {
//     try {
//       setLoading(true);
//       await bookingplanService.updateBookingPlanStatus(id, status);
//       toast.success(`? Booking marked as ${status}`);
      
//       // Clears block row cache and updates current visual grid page view seamlessly
//       if (gridApiRef.current) {
//         gridApiRef.current.refreshInfiniteCache();
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error('Unable to update booking status');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditNavigation = (id) => {
//     history.push(`/booking/new-session/${id}`);
//   };

//   const setFilter = (key, value) => {
//     setFilters((prev) => ({ ...prev, [key]: value }));
//   };

//   const clearFilters = () => {
//     setFilters({ search: '', status: '', date_from: '', date_to: '', doctor_id: '', room_id: '' });
//     gridApiRef.current?.setFilterModel(null);
//   };

//   const hasFilters = Boolean(
//     filters.search || filters.status || filters.date_from || filters.date_to || filters.doctor_id || filters.room_id
//   );
//   const hasAnyFilters = hasFilters || columnFiltersActive;
 

//   const columnDefs = [
  	
//   /*  {
//       field: 'main',
//       headerName: 'MAIN',
//       cellClass: ['ag-cell-center'],
//       headerClass: 'ag-header-left',
//       minWidth: 120,
//       flex: 0.8,
//       cellRendererFramework: (params) => {
//         const row = params.data;
//         if (!row) return null;
//         return row.patient_id
//           ? <span style={{ fontWeight: 600, color: '#0f172a' }}>{row.patient_id}</span>
//           : <span style={{ color: '#94a3b8' }}>-</span>;
//       },
//     },
//     {
//       field: 'ipopnumber',
//       headerName: 'IP / OP No.',
//       cellClass: ['ag-cell-center'],
//       headerClass: 'ag-header-left',
//       minWidth: 130,
//       flex: 0.8,
//       cellRendererFramework: (params) => {
//         const row = params.data;
//         if (!row) return null;
//         if (!row.ipopnumber) return <span style={{ color: '#94a3b8' }}>-</span>;
//         return (
//           <div style={{ lineHeight: '1.4', padding: '4px 0' }}>
//             <div style={{ fontWeight: 600, color: '#0f172a' }}>{row.ipopnumber}</div>
//             <div style={{ fontSize: 12, color: '#64748b' }}>{row.visit_type || '-'}</div>
//           </div>
//         );
//       },
//     },*/
//         {
//       field: 'patient_id',
//       headerName: 'Patient ID',
//       cellClass: ['ag-cell-center'],
//       headerClass: 'ag-header-left',
//       minWidth: 150,
//       flex: 1,
//       cellRendererFramework: (params) => {
//         const row = params.data;
//         if (!row) return null;
//         const hasMain = row.patient_id;
//         const hasIop = row.ipopnumber;
//         if (!hasMain && !hasIop) return <span style={{ color: '#94a3b8' }}>-</span>;
//         return (
//           <div style={{ lineHeight: '1.4', padding: '4px 0' }}>
//             {hasMain && (
//               <div style={{ fontSize: 11, color: '#64748b' }}>
//                 ID: {row.patient_id}
//               </div>
//             )}
//             {hasIop && (
//               <div style={{ fontWeight: 600, color: '#0f172a' }}>
//                 {row.ipopnumber}
                 
//                 {/* {row.visit_type && <span style={{ fontSize: 11, color: '#64748b' }}> ({row.visit_type})</span>} */}
//               </div>

             
               
//             )}
//             {/* {hasIop &&(
//  <div style={{ fontWeight: 600, color: '#0f172a' }}>
//                                   {row.visit_type && <span style={{ fontSize: 11, color: '#64748b' }}> ({row.visit_type})</span>}

//                    </div>
//             )} */}
//           </div>
//         );
//       },
//     },
//     {
//       field: 'patient_name',
//       headerName: 'Patient Details',
//       cellClass: ['ag-cell-center'],
//       headerClass: 'ag-header-left',
//       minWidth: 220,
//       flex: 2,
//       cellRendererFramework: (params) => {
//         const row = params.data;
//         if (!row) return null;
//         return (
//           <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '4px 0' }}>
//             <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', color: '#475569', flexShrink: 0 }}>
//               {(row.patient_name || 'P').charAt(0)}
//             </div>
//             <div style={{ lineHeight: '1.4', minWidth: 0 }}>
//               <div style={{ fontWeight: 600, color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.patient_name || 'No Patient'}</div>
//               <div style={{ fontSize: 12, color: '#64748b' }}>
//                 {row.patient_code ? <span>ID: {row.patient_code}</span> : null}
//                 {!row.patient_code && row.phone ? <span>?? {row.phone}</span> : null}
//               </div>
//             </div>
//           </div>
//         );
//       }
//     },
//     {
//       field: 'doctor_name',
//       headerName: 'Doctor / Department',
//       cellClass: ['ag-cell-center'],
//       headerClass: 'ag-header-left',
//       minWidth: 220,
//       flex: 1.5,
//       filter: true,
//       cellRendererFramework: (params) => {
//         const row = params.data;
//         if (!row) return null;
//         return (
//           <div style={{ padding: '4px 0', lineHeight: '1.4' }}>
//             <div style={{ fontWeight: 600, color: '#0f172a' }}>{row.doctor_name}</div>
//             <div style={{ fontSize: 12, color: '#64748b' }}>{getDoctorDepartmentFromPlan(row)}</div>
//           </div>
//         );
//       },
//     },
//     {
//       field: 'package_name',
//       headerName: 'Package / Session',
//       cellClass: ['ag-cell-center'],
//       headerClass: 'ag-header-left',
//       minWidth: 210,
//       flex: 1.4,
//       cellRendererFramework: (params) => {
//         const row = params.data;
//         if (!row) return null;

//         const currentSession = Number(row.session_number) || 1;
//         const totalSessions = Number(row.total_sessions) || Number(row.total_days) || 1;
//         const aggregateCompleted = Number(row.completed_sessions) || 0;
//         const currentRowCompleted = String(row.status || '').trim().toLowerCase() === 'completed';

//         // A completed current session must never appear as incomplete when an
//         // older or cached API response does not include the aggregate count.
//         const completedSessions = Math.min(
//           Math.max(aggregateCompleted, currentRowCompleted ? currentSession : 0),
//           totalSessions
//         );

//         // Some services are not linked to a package (package_id is NULL). In
//         // that case show the saved service instead of "General Treatment".
//         const packageLabel =
//           row.package_name ||
//           row.package_service_name ||
//           row.treatment_name ||
//           'Individual treatment';
//         const serviceLabel =
//           row.package_name && row.package_service_name
//             ? row.package_service_name
//             : null;

//         return (
//           <div style={{ padding: '4px 0', lineHeight: '1.35', minWidth: 0 }}>
//             <div
//               title={serviceLabel ? `${packageLabel} - ${serviceLabel}` : packageLabel}
//               style={{
//                 fontWeight: 600,
//                 color: '#0f172a',
//                 whiteSpace: 'nowrap',
//                 overflow: 'hidden',
//                 textOverflow: 'ellipsis',
//               }}
//             >
//               {packageLabel}
//             </div>
//             {serviceLabel && (
//               <div
//                 style={{
//                   fontSize: 12,
//                   color: '#64748b',
//                   whiteSpace: 'nowrap',
//                   overflow: 'hidden',
//                   textOverflow: 'ellipsis',
//                 }}
//               >
//                 {serviceLabel}
//               </div>
//             )}
//             <div style={{ display: 'flex', gap: 8, marginTop: 2, fontSize: 11, whiteSpace: 'nowrap' }}>
//               <span style={{ color: '#1d4ed8', fontWeight: 600 }}>
//                 Session {currentSession}/{totalSessions}
//               </span>
//               <span style={{ color: completedSessions === totalSessions ? '#15803d' : '#64748b' }}>
//                 {completedSessions}/{totalSessions} completed
//               </span>
//             </div>
//           </div>
//         );
//       },
//     },
//     // {
//     //   field: 'session_number',
//     //   headerName: 'Session #',
//     //   editable: (params) => !['Completed', 'Cancelled'].includes(params.data?.status),
//     //   cellClass: ['ag-cell-center'],
//     //   headerClass: 'ag-header-left',
//     //   minWidth: 90,
//     //   flex: 0.5,
//     //   cellRendererFramework: (params) => {
//     //     return <span style={{ fontWeight: 500, color: '#0f172a' }}>{params.value || '-'}</span>;
//     //   },
//     // },
//     // {
//     //   field: 'total_sessions',
//     //   headerName: 'Total Sessions',
//     //   editable: (params) => !['Completed', 'Cancelled'].includes(params.data?.status),
//     //   cellClass: ['ag-cell-center'],
//     //   headerClass: 'ag-header-left',
//     //   minWidth: 90,
//     //   flex: 0.5,
//     //   cellRendererFramework: (params) => {
//     //     return <span style={{ fontWeight: 500, color: '#0f172a' }}>{params.value || '-'}</span>;
//     //   },
//     // },
//     {
//       field: 'medicine_oil',
//       headerName: 'Medicine / Oil',
//       editable: (params) => !['Completed', 'Cancelled', 'Modified'].includes(params.data?.status),
//       cellClass: ['ag-cell-center'],
//       headerClass: 'ag-header-left',
//       minWidth: 150,
//       flex: 0.9,
//       cellRendererFramework: (params) => {
//         return <span style={{ fontWeight: 500, color: '#0f172a' }}>{params.value || '-'}</span>;
//       },
//     },
//     // {
//     //   field: 'notes',
//     //   headerName: 'Notes',
//     //   editable: (params) => !['Completed', 'Cancelled'].includes(params.data?.status),
//     //   cellClass: ['ag-cell-center'],
//     //   headerClass: 'ag-header-left',
//     //   minWidth: 180,
//     //   flex: 1,
//     //   cellRendererFramework: (params) => {
//     //     const value = params.value;
//     //     if (!value) return <span style={{ color: '#94a3b8' }}>-</span>;
//     //     return (
//     //       <span style={{ fontWeight: 500, color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
//     //         {value.length > 30 ? value.substring(0, 30) + '...' : value}
//     //       </span>
//     //     );
//     //   },
//     // },
//    /* {
//       field: 'created_at',
//       headerName: 'Booking Time',
//       cellClass: ['ag-cell-center'],
//       headerClass: 'ag-header-left',
//       minWidth: 160,
//       flex: 1,
//       cellRendererFramework: (params) => {
//         const row = params.data;
//         if (!row) return null;
       
//           // <div style={{ padding: '4px 0', lineHeight: '1.4' }}>
//           //   <div style={{ fontWeight: 500, fontSize: 13 }}>{row.created_at}</div>
//           // </div>
//           if (!row.created_at) return <span style={{ color: '#94a3b8' }}>-</span>;
//         return (
//           <div style={{ padding: '4px 0', lineHeight: '1.4' }}>
//             <div style={{ fontWeight: 500, fontSize: 13 }}>{formatDateTime12h(row.created_at)}</div>
//           </div>
        
//         );
//       },
//     },*/
//      {
//       field: 'schedule',
//       headerName: 'Schedule',
//       cellClass: ['ag-cell-center'],
//       headerClass: 'ag-header-left',
//       minWidth: 180,
//       flex: 1.2,
//       cellRendererFramework: (params) => {
//         const row = params.data;
//         if (!row) return null;
//         const hasDate = row.start_date;
//         const hasTime = row.start_time || row.end_time;
//         const hasBookingTime = row.created_at;
        
//         if (!hasDate && !hasTime && !hasBookingTime) {
//           return <span style={{ color: '#94a3b8' }}>-</span>;
//         }
        
//         return (
//           <div style={{ padding: '4px 0', lineHeight: '1.4' }}>
//             {hasDate && (
//               <div style={{ fontWeight: 600, color: '#0f172a' }}>{row.start_date}</div>
//             )}
//             {hasTime && (
//               <div style={{ fontSize: 12, color: '#64748b' }}>
//                 {row.start_time ? formatTime12h(row.start_time) : '--'} to {row.end_time ? formatTime12h(row.end_time) : '--'}
//               </div>
//             )}
//             {hasBookingTime && (
//               <div style={{ fontSize: 10, color: '#94a3b8', marginTop: '2px' }}>
//                 Booked: {formatDateTime12h(row.created_at)}
//               </div>
//             )}
//           </div>
//         );
//       },
//     },

//     {
//       field: 'room_number',
//       headerName: 'Room',
//       cellClass: ['ag-cell-center'],
//       headerClass: 'ag-header-left',
//       minWidth: 180,
//       flex: 1,
//       filter: true,
//       cellRendererFramework: (params) => {
//         const row = params.data;
//         if (!row) return null;
//         const code = row.room_code || row.roomcode || '';
//         const name = row.room_number || row.room_name || row.roomname || '';
//         return <span style={{ fontWeight: 500 }}>{code && name ? `${code} - ${name}` : code || name || '-'}</span>;
//       },
//     },
//  /*   {
//       field: 'start_date',
//       headerName: 'Date / Time',
//       cellClass: ['ag-cell-center'],
//       headerClass: 'ag-header-left',
//       minWidth: 180,
//       flex: 1.2,
//       cellRendererFramework: (params) => {
//         const row = params.data;
//         if (!row) return null;
//         return (
//           <div style={{ padding: '4px 0', lineHeight: '1.4' }}>
//             <div style={{ fontWeight: 600, color: '#0f172a' }}>{row.start_date || '-'}</div>
//             {/* <div style={{ fontSize: 12, color: '#64748b' }}>
//               {row.start_time ? row.start_time.slice(0, 5) : '--'} to {row.end_time ? row.end_time.slice(0, 5) : '--'}
//             </div> */
//       //       <div style={{ fontSize: 12, color: '#64748b' }}>
//       //         {row.start_time ? formatTime12h(row.start_time) : '--'} to {row.end_time ? formatTime12h(row.end_time) : '--'}
//       //       </div>
//       //     </div>
//       //   );
//       // }
//    // },
//     // -- NEW: Visit ID Column -------------------------------
//     // {
//     //   field: 'visit_id',
//     //   headerName: 'Visit ID',
//     //   cellClass: ['ag-cell-center'],
//     //   headerClass: 'ag-header-left',
//     //   minWidth: 100,
//     //   flex: 0.7,
//     //   cellRendererFramework: (params) => {
//     //     const row = params.data;
//     //     if (!row) return null;
//     //     const visitId = row.visit_id;
//     //     if (visitId) {
//     //       return (
//     //         <span style={{ fontWeight: 600, color: '#2563eb', fontFamily: 'monospace' }}>
//     //           {visitId}
//     //         </span>
//     //       );
//     //     }
//     //     return <span style={{ color: '#94a3b8' }}>-</span>;
//     //   }
//     // },
//     {
//       field: 'status',
//       headerName: 'Status',
//       cellClass: ['ag-cell-center'],
//       headerClass: 'ag-header-left',
//       minWidth: 130,
//       flex: 0.8,
//       cellRendererFramework: (params) => {
//         const row = params.data;
//         if (!row) return null;
//         return <Badge variant={statusVariant(row.status)}>{row.status || 'Scheduled'}</Badge>;
//       }
//     },
//     {
//       headerName: 'Actions',
//       field: 'actions',
//       cellClass: ['ag-cell-center'],
//       headerClass: 'ag-header-left',
//       sortable: false,
//       filter: false,
//       floatingFilter: false,
//       minWidth: 280,
//       flex: 1.5,
//       cellRendererFramework: (params) => {
//         const row = params.data;
//         if (!row) return null;

//         const status = String(row.status || '').toLowerCase();
//         const isCancelled = status === 'cancelled';
//         const isCompleted = status === 'completed';
//         const isBoarded = status === 'boarded';
//         const isTerminal = isCancelled || isCompleted;
//         const hasVisitId = Boolean(row.visit_id);

//         return (
//           <div style={{ display: 'flex', gap: 4, alignItems: 'center', height: '100%', flexWrap: 'wrap' }}>
//             {/* Edit button - always visible unless terminal */}
//             {!isTerminal && (
//               <Button variant="ghost" size="icon" title="Edit Booking" onClick={() => handleEditNavigation(row.id)}>
//                 <Edit2 size={16} />
//               </Button>
//             )}

//             {/* Board Patient button - only before boarding (no visit_id, not terminal) */}
//             {!hasVisitId && !isTerminal && !isBoarded && (
//               <Button
//                 variant="ghost"
//                 size="icon"
//                 title="Board Patient"
//                 onClick={() => handleOpenBoardModal(row)}
//                 style={{ color: '#2563eb' }}
//               >
//                 <LogIn size={16} />
//               </Button>
//             )}

//             {/* Mark Complete button - only when boarded (has visit_id) and not completed */}
//             {hasVisitId && !isCompleted && !isCancelled && (
//               <Button
//                 variant="ghost"
//                 size="icon"
//                 title="Mark Complete"
//                 onClick={() => handleOpenCompleteModal(row)}
//                 style={{ color: '#16a34a' }}
//               >
//                 <CheckCircle size={16} />
//               </Button>
//             )}

//             {/* Completed badge */}
//             {isCompleted && (
//               <span style={{
//                 fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 999,
//                 background: '#dcfce7', color: '#166534',
//               }}>
//                 ? Completed
//               </span>
//             )}

//             {/* Cancelled badge */}
//             {isCancelled && (
//               <span style={{
//                 fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 999,
//                 background: '#fef2f2', color: '#991b1b',
//               }}>
//                 ? Cancelled
//               </span>
//             )}

//             {/* Cancel button - only for non-terminal bookings */}
//             {!isTerminal && (
//               <Button variant="ghost" size="icon" title="Cancel Booking" onClick={() => handleOpenCancelModal(row)}>
//                 <XCircle size={16} color="#dc2626" />
//               </Button>
//             )}
//           </div>
//         );
//       },
//     },
//   ];

//   const onGridReady = useCallback((params) => {
//     gridApiRef.current = params.api;
//     updateDatasource(params.api, appliedFilters);
//   }, [appliedFilters, updateDatasource]);

//   return (
//     <div className="page-container fade-in">
//       {/* Modals */}
//       {boardModal.open && (
//         <BoardPatientModal
//           bookingId={boardModal.id}
//           bookingCode={boardModal.code}
//           patientName={boardModal.patientName}
//           patientId={boardModal.patientId}
//           visitId={boardModal.visitId}
//           onClose={() => setBoardModal({ open: false, id: null, code: null, patientName: null, patientId: null, visitId: null })}
//           onSuccess={(bookingId, newVisitId) => handleModalSuccess(bookingId, boardModal.patientId, newVisitId)}
//         />
//       )}
//       {completeModal.open && (
//         <CompleteBookingModal
//           bookingId={completeModal.id}
//           bookingCode={completeModal.code}
//           patientName={completeModal.patientName}
//           onClose={() => setCompleteModal({ open: false, id: null, code: null, patientName: null })}
//           onSuccess={handleModalSuccess}
//         />
//       )}
//       {cancelModal.open && (
//         <CancelBookingModal
//           bookingId={cancelModal.id}
//           bookingCode={cancelModal.code}
//           patientName={cancelModal.patientName}
//           onClose={() => setCancelModal({ open: false, id: null, code: null, patientName: null })}
//           onSuccess={handleModalSuccess}
//         />
//       )}

//       {/* Header Bar */}
//       <div className="booking-page-header">
//         <div className="booking-page-search">
//           <Search size={18} />
//           <input
//             type="text"
//             placeholder="Search Patients By Name / PhoneNumber / MAIN / Aadhaar Number..."
//             value={filters.search}
//             onChange={(e) => setFilter('search', e.target.value)}
//           />
//         </div>
//         <div className="booking-page-actions">
//           <Button variant={showFilters ? 'primary' : 'ghost'} size="icon" onClick={() => setShowFilters(!showFilters)}>
//             <Filter size={18} />
//           </Button>
//           <Button onClick={() => history.push('/booking/new-session', { from: 'booking' })}>
//             <Plus size={18} /> New Booking
//           </Button>
//         </div>
//       </div>

//       {/* Title */}
//       <div className="booking-page-title-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15 }}>
//         <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
//           <h2 style={{ margin: 0 }}>Booking Plans</h2>
//           {!hasAnyFilters && (
//             <span style={{
//               fontSize: 12, fontWeight: 700, padding: '3px 10px', borderRadius: 999,
//               background: '#dbeafe', color: '#1e40af',
//             }}>
//               ?? Today & Upcoming
//             </span>
//           )}
//           {hasAnyFilters && (
//             <span style={{
//               fontSize: 12, fontWeight: 700, padding: '3px 10px', borderRadius: 999,
//               background: '#fef3c7', color: '#92400e',
//             }}>
//               ?? Filtered (all records)
//             </span>
//           )}
//         </div>
//       </div>

//       {/* Row colour legend */}
//       <div style={{ display: 'flex', gap: 16, marginBottom: 12, fontSize: 12, flexWrap: 'wrap' }}>
//         <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
//           <span style={{ width: 12, height: 12, background: '#fef2f2', border: '2px solid #f87171', borderRadius: 2, display: 'inline-block' }} />
//           No doctor & no room assigned
//         </span>
//         <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
//           <span style={{ width: 12, height: 12, background: '#fffbeb', border: '2px solid #fbbf24', borderRadius: 2, display: 'inline-block' }} />
//           Partially assigned (doctor or room missing)
//         </span>
//         <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
//           <span style={{ width: 12, height: 12, background: '#fff', border: '2px solid #86efac', borderRadius: 2, display: 'inline-block' }} />
//           Fully assigned
//         </span>
//       </div>

//       {/* Advanced Filtering Panel */}
//       {showFilters && (
//         <div className="ui-card filter-panel" style={{ marginBottom: 20, padding: '15px' }}>
//           <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
//             <div className="filter-group">
//               <label className="filter-label">Status</label>
//               <select className="form-control" value={filters.status} onChange={(e) => setFilter('status', e.target.value)}>
//                 <option value="">All Status</option>
//                 <option value="Scheduled">Scheduled</option>
//                 <option value="Boarded">Boarded</option>
//                 <option value="Completed">Completed</option>
//                 <option value="Cancelled">Cancelled</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label className="filter-label">Doctor</label>
//               <select className="form-control" value={filters.doctor_id} onChange={(e) => setFilter('doctor_id', e.target.value)} disabled={loadingDropdowns}>
//                 <option value="">{loadingDropdowns ? 'Loading doctors...' : 'All Doctors'}</option>
//                 {doctors.length > 0 && doctors.map((d) => (
//                   <option key={getDoctorLookupId(d) || Math.random()} value={getDoctorLookupId(d)}>
//                     {getDoctorDisplayName(d)}
//                   </option>
//                 ))}
//               </select>
//               {!loadingDropdowns && doctors.length === 0 && (
//                 <div style={{ fontSize: 11, color: '#dc2626', marginTop: 4 }}>No doctors available</div>
//               )}
//             </div>
//             <div className="filter-group">
//               <label className="filter-label">Room</label>
//               <select className="form-control" value={filters.room_id} onChange={(e) => setFilter('room_id', e.target.value)} disabled={loadingDropdowns}>
//                 <option value="">{loadingDropdowns ? 'Loading rooms...' : 'All Rooms'}</option>
//                 {rooms.length > 0 && rooms.map((r) => {
//                   const roomId = getRoomLookupId(r);
//                   return (
//                     <option key={roomId || Math.random()} value={roomId}>
//                       {getRoomDisplayName(r)}
//                     </option>
//                   );
//                 })}
//               </select>
//               {!loadingDropdowns && rooms.length === 0 && (
//                 <div style={{ fontSize: 11, color: '#dc2626', marginTop: 4 }}>No rooms available</div>
//               )}
//             </div>
//             <div className="filter-group">
//               <label className="filter-label">From Date</label>
//               <input type="date" className="form-control" value={filters.date_from} onChange={(e) => setFilter('date_from', e.target.value)} />
//             </div>
//             <div className="filter-group">
//               <label className="filter-label">To Date</label>
//               <input type="date" className="form-control" value={filters.date_to} onChange={(e) => setFilter('date_to', e.target.value)} />
//             </div>
//             <Button type="button" variant="secondary" onClick={clearFilters} disabled={!hasAnyFilters} style={{ alignSelf: 'flex-end' }}>
//               Clear Filters
//             </Button>
//           </div>
//         </div>
//       )}

//       {/* Active filter indicator */}
//       {hasAnyFilters && (
//         <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
//           <span style={{ fontSize: 13, color: '#64748b', fontWeight: 500 }}>
//             Active filters applied
//           </span>
//           <span className="ui-badge ui-badge-blue" style={{ fontSize: 11, padding: '3px 10px' }}>
//             {[
//               filters.status && 'Status',
//               filters.doctor_id && 'Doctor',
//               filters.room_id && 'Room',
//               (filters.date_from || filters.date_to) && 'Date Range',
//               filters.search && 'Search',
//               columnFiltersActive && 'Column filters',
//             ].filter(Boolean).join(', ')}
//           </span>
//         </div>
//       )}

//       {/* Grid with automated infinite scrolling / server side pagination */}
//       <div className="p-3 preview">
//         <div className="ag-theme-balham style card rounded" style={{ fontSize: "14px", height: 630, width: "100%" }}>
//           <AgGridReact
//             ref={gridRef}
//             columnDefs={columnDefs}
//             defaultColDef={defaultColDef}
            
//             // Core Native Pagination Settings
//             rowModelType="infinite"
//             cacheBlockSize={DEFAULT_PAGE_SIZE}
//             pagination={true}
//             paginationPageSize={DEFAULT_PAGE_SIZE}
//             onGridReady={onGridReady}
//             onFilterChanged={(event) => {
//               setColumnFiltersActive(Object.keys(event.api.getFilterModel() || {}).length > 0);
//             }}
//             rowHeight={70}
//             getRowHeight={(params) => {
//               if (params.data?.start_time) return 55;
//               return 35;
//             }}
//             getRowStyle={(params) => {
//               if (!params.data) return undefined;
//               const cls = getRowClass(params.data);
//               if (cls === 'row-unassigned') return { background: '#fef2f2', borderLeft: '3px solid #f87171' };
//               if (cls === 'row-partial') return { background: '#fffbeb', borderLeft: '3px solid #fbbf24' };
//               return { background: 'white' };
//             }}
//             overlayNoRowsTemplate={`<span style="color:#6b7280;padding:20px;display:block">No booking plans found</span>`}
//           />
//         </div>
//         {/* Total matching records indicator synced directly to current interactive page layout */}
//         <div style={{ marginTop: 12, fontSize: 13, color: '#64748b' }}>
//           {/* Showing <b>{startRecord}</b> to <b>{endRecord}</b> of <b>{totalRecords}</b> matching records */}
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Plus, Search, Filter, Edit2, CheckCircle, XCircle, X, AlertTriangle, MessageSquare, UserCheck, LogIn, PlayCircle } from 'lucide-react';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import './styles/appointments.css';

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import Button from './ui/Button';
import Badge, { statusVariant } from './ui/Badge';
import bookingplanService from '../../core/services/bookingplanService';
import { apiFetch } from '../../shared/helper/apiFetch';
import doctorServices from '../../core/services/doctorServices';
import roomServices from '../../core/services/roomServices';
import { useDispatch } from 'react-redux';
import { patientActions } from '../../core/actions';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const getPlanAssignment = (plan) => {
  const hasDoctor = Boolean(
    plan.doctor_id || plan.counselor || plan.doctor_name || plan.counselor_name || plan.doctor_identifier || plan.doctor_type || plan.first_name
  );
  const hasRoom = Boolean(plan.room_id || plan.room_number);
  return { hasDoctor, hasRoom };
};

const defaultColDef = {
  editable: false,
  sortable: true,
  flex: 1,
  minWidth: 100,
  filter: true, // Disable all column filters - using advanced filter panel
  resizable: true,
  floatingFilter: true, // Disable floating filters
};

const getRowClass = (plan) => {
  const { hasDoctor, hasRoom } = getPlanAssignment(plan);
  if (!hasDoctor && !hasRoom) return 'row-unassigned';
  if (!hasDoctor || !hasRoom) return 'row-partial';
  return '';
};

const normalizeApiList = (response) => {
  if (!response) return [];
  if (Array.isArray(response?.data?.data)) return response.data.data;
  if (Array.isArray(response?.accresp?.personList)) return response.accresp.personList;
  if (Array.isArray(response?.roomList)) return response.roomList;
  if (Array.isArray(response?.personList)) return response.personList;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response)) return response;
  return [];
};

const getDoctorDisplayName = (doctor) => {
  if (!doctor) return 'Unassigned';
  if (doctor.label) return doctor.label;
  if (doctor.doctor_name) return doctor.doctor_name;
  if (doctor.name || doctor.fullName) {
    const title = doctor.displaytitle || doctor.title || doctor.degree || '';
    const name = [doctor.first_name, doctor.mname, doctor.last_name, doctor.name, doctor.fullName]
      .filter(Boolean).join(' ').trim();
    if (title && name) return `${title} ${name}`;
    if (name) return name;
  }
  if (doctor.doctor_identifier || doctor.identifier) {
    return [doctor.doctor_identifier || doctor.identifier, doctor.doctor_type || doctor.type]
      .filter(Boolean)
      .join(' - ');
  }
  if (doctor.displayName) return doctor.displayName;
  return [doctor.displaytitle || doctor.title || doctor.degree || '']
    .concat([doctor.first_name, doctor.mname, doctor.last_name].filter(Boolean))
    .filter(Boolean)
    .join(' ') || 'Unassigned';
};

const getRoomDisplayName = (room) => {
  if (!room) return 'No Room';
  const code = room.roomCode || room.room_code || room.code || room.roomNo || room.room_number || '';
  const name = room.roomName || room.room_name || room.room_number || room.roomNumber || room.roomname || room.name || room.title || room.label || '';
  if (code && name) return `${code} - ${name}`;
  return name || code || room.label || 'Room';
};
// -- time formatting helpers --------------------------------
const formatTime12h = (timeStr) => {
  if (!timeStr) return null;
  const match = String(timeStr).match(/(\d{1,2}):(\d{2})(?::(\d{2}))?/);
  if (!match) return timeStr;
  let hours = parseInt(match[1], 10);
  const minutes = match[2];
  const period = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  if (hours === 0) hours = 12;
  return `${hours}:${minutes} ${period}`;
};

const formatDateTime12h = (dateTimeStr) => {
  if (!dateTimeStr) return null;
  const str = String(dateTimeStr);
  const sepIdx = str.indexOf(' ') !== -1 ? str.indexOf(' ') : str.indexOf('T');
  if (sepIdx === -1) return formatTime12h(str); // it's just a bare time, no date part
  const datePart = str.slice(0, sepIdx);
  const timePart = str.slice(sepIdx + 1);
  const formattedTime = formatTime12h(timePart);
  return formattedTime ? `${datePart} ${formattedTime}` : str;
};

// -- Modal Components ---------------------------------------

const ModalOverlay = ({ children, onClose }) => (
  <div style={{
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center',
    justifyContent: 'center', zIndex: 9999,
  }} onClick={onClose}>
    <div style={{
      background: '#fff', borderRadius: 12, padding: 24, width: 480,
      maxWidth: '90vw', boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    }} onClick={(e) => e.stopPropagation()}>
      {children}
    </div>
  </div>
);

const BoardPatientModal = ({ bookingId, bookingCode, patientName, patientId, visitId, bookingStartDate, onClose, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);
  const [selectedRadio, setSelectedRadio] = useState("OutPatient");
  const todayStr = new Date().toISOString().split('T')[0];
  // Booking plans dated before today need an explicit onboarding date/time from the
  // user, since the actual boarding is happening later than the plan's scheduled date.
  const isPreviousDated = Boolean(bookingStartDate) && String(bookingStartDate).slice(0, 10) < todayStr;
  const [selecteddate, setSelecteddate] = useState(
    isPreviousDated ? String(bookingStartDate).slice(0, 10) : todayStr
  );
  const [selectedTime, setSelectedTime] = useState(format(new Date(), "HH:mm"));
  const [boardError, setBoardError] = useState('');

  const needsDateTime = selectedRadio === "InPatient" || selectedRadio === "Walkin" || isPreviousDated;

  const handleBoard = async () => {
    setBoardError('');
    if (isPreviousDated && (!selecteddate || !selectedTime)) {
      setBoardError('This booking plan is dated in the past. Please enter the date and time of onboarding.');
      return;
    }
    try {
      setSubmitting(true);
        const hasSpecialVisitFlag =
          selectedRadio === "Walkin" || selectedRadio === "Proxy";
        const boardingPayload = {
          type:
            selectedRadio === "Walkin"
              ? "InPatient"
              : selectedRadio === "Proxy"
                ? "OutPatient"
                : selectedRadio,
          visitFlag: hasSpecialVisitFlag ? selectedRadio : null,
          admissionDate: needsDateTime
            ? `${selecteddate} ${selectedTime}:00`
            : "",
        };
        const result = await bookingplanService.boardPatient(bookingId, boardingPayload);

      if (result) {
        const siblingCount = (result?.data?.boarded_booking_ids || result?.boarded_booking_ids || []).length;
        toast.success(
          siblingCount > 0
            ? `Patient boarded successfully; also boarded ${siblingCount} other booking plan(s) for the same date`
            : 'Patient boarded successfully'
        );
        // Pass bookingId and the new visitId from the response
        const newVisitId = result?.data?.visit_id || result?.visit_id || visitId;
        onSuccess(bookingId, newVisitId);
        onClose();
      }
    } catch (err) {
      console.error(err);
      // apiFetch rejects with a plain string for server-side errors (data.message/
      // errormsg/errorMessages[0]) and only rejects with an Error object for network
      // failures � read both shapes so the server's actual reason is never dropped.
      const rawMsg = typeof err === 'string'
        ? err
        : (err?.message || err?.data?.message || err?.data?.data || '');
      const cleanMsg = rawMsg
        .replace(/^Error[:\s]*/i, '')
        .replace(/^Failed to board patient[:\s]*/i, '')
        .trim();
      const msg = cleanMsg || 'Cannot board patient. Please try again.';
      setBoardError(msg);
      toast.error(`Error: ${msg}`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
      className="d-flex w-95 h-90 flex-column-reverse dialog"
      maxWidth="sm"
      fullWidth
    >
      <div>
        <DialogTitle>
          Select Patient Category
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ padding: '0px 24px' }}>
          <span>
            Are you sure to OnBoard a patient {patientName}? This will board all
            active booking plans scheduled for this patient on the same date.
          </span>
          {isPreviousDated && (
            <div style={{
              display: 'flex', alignItems: 'flex-start', gap: 8,
              background: '#eff6ff', border: '1px solid #bfdbfe',
              color: '#1e3a8a', padding: '10px 14px', borderRadius: 8,
              marginTop: 12, fontSize: 13.5, lineHeight: 1.4,
            }}>
              <AlertTriangle size={16} style={{ flexShrink: 0, marginTop: 1 }} />
              <span>This booking plan is dated {bookingStartDate}, which is in the past. Please enter the actual date and time of onboarding below.</span>
            </div>
          )}
          {boardError && (
            <div style={{
              display: 'flex', alignItems: 'flex-start', gap: 8,
              background: '#fffbeb', border: '1px solid #fde68a',
              color: '#92400e', padding: '10px 14px', borderRadius: 8,
              marginTop: 12, fontSize: 13.5, lineHeight: 1.4,
            }}>
              <AlertTriangle size={16} style={{ flexShrink: 0, marginTop: 1 }} />
              <span>{boardError}</span>
            </div>
          )}
        </DialogContent>
        <DialogActions
          className="d-flex flex-column align-items-end"
          style={{ paddingTop: '0px' }}
        >
          <RadioGroup
            row
            aria-label="patientCategory"
            name="patientCategory"
            value={selectedRadio}
            onChange={(e) => { setSelectedRadio(e.target.value); setBoardError(''); }}
            className="d-flex w-100 justify-content-between"
          >
            <FormControlLabel
              value="InPatient"
              control={<Radio />}
              label="InPatient"
            />
            <FormControlLabel
              value="OutPatient"
              control={<Radio />}
              label="OutPatient"
            />
            <FormControlLabel
              value="Walkin"
              control={<Radio />}
              label="Walk In"
            />
            <FormControlLabel
              value="Proxy"
              control={<Radio />}
              label="Proxy"
            />
      
          </RadioGroup>
          {needsDateTime ? (
            <div
              className="d-flex justify-content-end"
              style={{
                flexDirection: 'column',
                padding: '0px 10px',
                marginRight: 'auto',
              }}
            >
              <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginTop: 12, marginBottom: 6, color: '#475569' }}>
                {selectedRadio === "InPatient" || selectedRadio === "Walkin"
                  ? "Select Admission Date & Time:"
                  : "Select Onboarding Date & Time:"}
              </label>
              <div style={{ display: 'flex', gap: 12, padding: 16, background: '#f8fafc', borderRadius: 8 }}>
                <div style={{ flex: 1 }}>
                  <input
                    type="date"
                    value={selecteddate}
                    onChange={(e) => setSelecteddate(e.target.value)}
                    style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <input
                    type="time"
                    value={selectedTime}
                    onChange={(e) => setSelectedTime(e.target.value)}
                    style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }}
                  />
                </div>
              </div>   
            </div>
          ) : (
            ""
          )}
          <Button
            variant="contained"
            color="primary"
            className="btn-style bottomright mt-2"
            onClick={handleBoard}
            disabled={submitting}
            style={{ textTransform: 'none', marginRight: '15px' }}
          >
            {submitting ? 'Boarding...' : 'Save'}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

const StartSessionModal = ({ bookingId, patientName, onClose, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  const handleStart = async () => {
    try {
      setSubmitting(true);
      await bookingplanService.startBookingSession(bookingId);
      toast.success('Session started successfully');
      onSuccess();
      onClose();
    } catch (err) {
      console.error(err);
      const rawMsg = err?.message || err?.data?.message || '';
      const cleanMsg = rawMsg
        .replace(/^Error[:\s]*/i, '')
        .replace(/^Failed to start session[:\s]*/i, '')
        .trim();
      toast.error(cleanMsg || 'Cannot start session. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ModalOverlay onClose={onClose}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
          <PlayCircle size={20} color="#d97706" /> Start Session
        </h3>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}>
          <X size={20} />
        </button>
      </div>
      <div style={{
        background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8,
        padding: '12px 16px', marginBottom: 20, fontSize: 14, color: '#78350f',
      }}>
        Start the session for patient <strong>{patientName || 'N/A'}</strong>?
      </div>
      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
        <Button variant="secondary" onClick={onClose} disabled={submitting}>Cancel</Button>
        <Button variant="primary" onClick={handleStart} disabled={submitting}>
          {submitting ? 'Starting...' : 'Start Session'}
        </Button>
      </div>
    </ModalOverlay>
  );
};

const CompleteBookingModal = ({ bookingId, bookingCode, patientName, onClose, onSuccess }) => {
  const [comments, setComments] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleComplete = async () => {
    try {
      setSubmitting(true);
      await bookingplanService.markBookingComplete(bookingId);
      toast.success('✅ Booking completed successfully');
      onSuccess();
      onClose();
    } catch (err) {
      console.error(err);
      const rawMsg = err?.message || err?.data?.message || '';
      const cleanMsg = rawMsg
        .replace(/^Error[:\s]*/i, '')
        .replace(/^Failed to complete booking[:\s]*/i, '')
        .trim();
      const msg = cleanMsg ? `Error: Cannot complete booking. ${cleanMsg}` : 'Error: Cannot complete booking. Please try again.';
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ModalOverlay onClose={onClose}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
          <CheckCircle size={20} color="#16a34a" /> Complete Booking
        </h3>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}>
          <X size={20} />
        </button>
      </div>
      <div style={{
        background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 8,
        padding: '12px 16px', marginBottom: 16, fontSize: 14, color: '#0c4a6e',
      }}>
        Are you sure to complete booking for patient <strong>{patientName || 'N/A'}</strong>?
      </div>
      {/* <p style={{ color: '#475569', marginBottom: 16, fontSize: 14 }}>
        Complete booking <strong>{bookingCode || `#${bookingId}`}</strong> and add any relevant notes.
      </p> */}
      <div style={{ marginBottom: 20 }}>
        <label style={{ display: 'block', fontWeight: 600, marginBottom: 6, fontSize: 14, color: '#334155' }}>
          Comments / Notes
        </label>
        <textarea
          value={comments}
          onChange={(e) => setComments(e.target.value)}
          placeholder="Enter completion notes (optional)..."
          rows={4}
          style={{
            width: '100%', padding: '10px 12px', border: '1px solid #d1d5db',
            borderRadius: 8, fontSize: 14, resize: 'vertical', boxSizing: 'border-box',
            fontFamily: 'inherit',
          }}
        />
      </div>
      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
        <Button variant="secondary" onClick={onClose} disabled={submitting}>Cancel</Button>
        <Button variant="primary" onClick={handleComplete} disabled={submitting}>
          {submitting ? 'Completing...' : 'Confirm Complete'}
        </Button>
      </div>
    </ModalOverlay>
  );
};

const CancelBookingModal = ({ bookingId, bookingCode, patientName, onClose, onSuccess }) => {
  const [cancelReason, setCancelReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleCancel = async () => {
    try {
      setSubmitting(true);
      await bookingplanService.updateBookingPlanStatusWithComments(bookingId, 'Cancelled', cancelReason);
      toast.success('✅ Booking cancelled successfully');
      onSuccess();
      onClose();
    } catch (err) {
      console.error(err);
      const rawMsg = err?.message || err?.data?.message || '';
      const cleanMsg = rawMsg
        .replace(/^Error[:\s]*/i, '')
        .replace(/^Failed to cancel booking[:\s]*/i, '')
        .trim();
      const msg = cleanMsg ? `Error: Cannot cancel booking. ${cleanMsg}` : 'Error: Cannot cancel booking. Please try again.';
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ModalOverlay onClose={onClose}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
          <AlertTriangle size={20} color="#dc2626" /> Cancel Booking Plan
        </h3>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}>
          <X size={20} />
        </button>
      </div>
      {/* <div style={{
        background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8,
        padding: '12px 16px', marginBottom: 16, fontSize: 14, color: '#991b1b',
      }}>
        <strong>Warning:</strong> Cancelling this booking will:
        <ul style={{ margin: '8px 0 0', paddingLeft: 20 }}>
          <li>Mark the booking as Cancelled</li>
          <li>Record cancellation date and time</li>
          <li>Remove the corresponding room status record</li>
          <li>Free up the assigned room</li>
        </ul>
      </div> */}
      <div style={{
        background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 8,
        padding: '12px 16px', marginBottom: 16, fontSize: 14, color: '#0c4a6e',
      }}>
        Are you sure to cancel booking for patient <strong>{patientName || 'N/A'}</strong>?
      </div>
      <p style={{ color: '#475569', marginBottom: 16, fontSize: 14 }}>
        Cancel booking <strong>{bookingCode || `#${bookingId}`}</strong>?
      </p>
      <div style={{ marginBottom: 20 }}>
        <label style={{ display: 'block', fontWeight: 600, marginBottom: 6, fontSize: 14, color: '#334155' }}>
          <MessageSquare size={14} style={{ marginRight: 4 }} /> Cancel Reason
        </label>
        <textarea
          value={cancelReason}
          onChange={(e) => setCancelReason(e.target.value)}
          placeholder="Enter reason for cancellation (optional)..."
          rows={3}
          style={{
            width: '100%', padding: '10px 12px', border: '1px solid #d1d5db',
            borderRadius: 8, fontSize: 14, resize: 'vertical', boxSizing: 'border-box',
            fontFamily: 'inherit',
          }}
        />
      </div>
      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
        <Button variant="secondary" onClick={onClose} disabled={submitting}>Keep Booking</Button>
        <Button
          variant="danger"
          onClick={handleCancel}
          disabled={submitting}
          style={{ background: '#dc2626', color: '#fff', border: 'none' }}
        >
          {submitting ? 'Cancelling...' : 'Confirm Cancel'}
        </Button>
      </div>
    </ModalOverlay>
  );
};

const AutoAdvanceCountdown = ({ active, durationMs, startedAt }) => {
  const [remainingMs, setRemainingMs] = useState(durationMs);

  useEffect(() => {
    if (!active) {
      setRemainingMs(durationMs);
      return undefined;
    }

    let mounted = true;
    const tick = () => {
      if (!mounted) return;

      const elapsed = Date.now() - startedAt;
      const remaining = Math.max(durationMs - elapsed, 0);
      setRemainingMs(remaining);
    };

    tick();
    const interval = setInterval(tick, 250);

    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, [active, durationMs, startedAt]);

  if (!active) return null;

  const progress = Math.min(1, Math.max(0, (durationMs - remainingMs) / durationMs));
  const size = 86;
  const stroke = 7;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const dashOffset = circumference * (1 - progress);

  return (
    <div className="booking-auto-advance" aria-live="polite" aria-label="Auto advancing booking plans">
      <div className="booking-auto-advance-ring">
        <svg className="booking-auto-advance-svg" viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
          <circle
            className="booking-auto-advance-track"
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={stroke}
          />
          <circle
            className="booking-auto-advance-progress"
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={stroke}
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
          />
        </svg>
        <div className="booking-auto-advance-ring-inner">
          <div className="booking-auto-advance-time">{Math.max(1, Math.ceil(remainingMs / 1000))}s</div>
          <div className="booking-auto-advance-label">Next page</div>
        </div>
      </div>
    </div>
  );
};

const getLocalDateString = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export default function BookingPlans() {
  const history = useHistory();
  const gridRef = useRef(null);
  const dispatch = useDispatch();
  // for handling booking plan view by therapist and therapist view  role
  const accessLevel = JSON.parse(localStorage.getItem("AccessLevel")) || "";
  const permissions = accessLevel
    .split(",")
    .map((permission) => permission.trim());
  const canManageBooking = permissions.includes("therapist_admin");
  const showSearchAndFilters = canManageBooking;

  // Callback to save inline cell edits to the backend
  const handleCellValueChanged = useCallback(async (event) => {
    const { data, colDef, newValue, oldValue } = event;
    if (newValue === oldValue) return;
    if (!data?.id) return;

    const field = colDef.field;
    // Only handle fields that can be updated via simple cell edit
    const allowedFields = ['medicine_oil', 'notes', 'session_number', 'total_sessions'];
    if (!allowedFields.includes(field)) return;

    try {
      // Build a minimal update payload with the changed field
      const updatePayload = { id: data.id };
      updatePayload[field] = newValue;

      // Include other key fields to prevent data loss
      if (data.doctor_id) updatePayload.doctor_id = data.doctor_id;
      if (data.room_id) updatePayload.room_id = data.room_id;
      
      await bookingplanService.updateBookingPlan(data.id, updatePayload);
      toast.success(`✅ ${colDef.headerName || field} updated`);
    } catch (err) {
      console.error('Failed to update cell:', err);
      toast.error(`Failed to update ${colDef.headerName || field}`);
      // Revert the cell to its previous value
      event.api.stopEditing();
      event.node.setDataValue(field, oldValue);
    }
  }, []);

  const [filters, setFilters] = useState({
    search: '',
    status: '',
    date_from: '',
    date_to: '',
    doctor_id: '',
    room_id: '',
    visit_type: '',
    treatment_type: '',
  });

  const [doctors, setDoctors] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [loadingDropdowns, setLoadingDropdowns] = useState(true);
  const [columnFiltersActive, setColumnFiltersActive] = useState(false);

  const getRoomLookupId = (room) =>
    room?.id || room?.room_id || room?.roomId || room?.roomNumber || room?.room_number || room?.code || room?.roomCode || '';

  // Modal states
  const [boardModal, setBoardModal] = useState({ open: false, id: null, code: null, patientName: null, patientId: null, startDate: null });
  const [startModal, setStartModal] = useState({ open: false, id: null, patientName: null });
  const [completeModal, setCompleteModal] = useState({ open: false, id: null, code: null, patientName: null });
  const [cancelModal, setCancelModal] = useState({ open: false, id: null, code: null, patientName: null });

  // Pagination states matching Ag-Grid's internal pagination indicators
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const currentPageRef = useRef(0);
  const [debouncedSearch, setDebouncedSearch] = useState('');

  // The 630px grid fits seven 70px booking rows plus its header and pager.
  // Keep this shared by the infinite-row cache, API limit, and pagination.
  const DEFAULT_PAGE_SIZE = 7;
  const AUTO_ADVANCE_MS = 50000;
  const gridApiRef = useRef(null);
  const [autoAdvanceStartedAt, setAutoAdvanceStartedAt] = useState(Date.now());

  // Dynamically calculate the records display string tracking variables 
  const startRecord = totalRecords > 0 ? currentPage * DEFAULT_PAGE_SIZE + 1 : 0;
  const endRecord = totalRecords > 0 ? Math.min(startRecord + DEFAULT_PAGE_SIZE - 1, totalRecords) : 0;
  const totalPages = totalRecords > 0 ? Math.ceil(totalRecords / DEFAULT_PAGE_SIZE) : 0;
  const shouldAutoAdvance = !canManageBooking && totalPages > 1;

  useEffect(() => {
    fetchDoctorsAndRooms();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(filters.search), 350);
    return () => clearTimeout(timer);
  }, [filters.search]);

  const appliedFilters = useMemo(() => ({
    search: debouncedSearch,
    status: filters.status,
    date_from: filters.date_from,
    date_to: filters.date_to,
    doctor_id: filters.doctor_id,
    room_id: filters.room_id,
    visit_type: filters.visit_type,
    treatment_type: filters.treatment_type,
  }), [debouncedSearch, filters.status, filters.date_from, filters.date_to,
    filters.doctor_id, filters.room_id, filters.visit_type, filters.treatment_type]);

  // This core handler configures a standard source model mapping Ag-Grid pagination triggers to API params
  const updateDatasource = useCallback((api, currentFilters) => {
    if (!api) return;

    const datasource = {
      getRows: async (params) => {
        try {
          setLoading(true);

          // Ag-Grid's startRow natively calculates your offset (e.g. Page 2 is startRow: 3)
          const offset = params.startRow;
          const limit = params.endRow - params.startRow;
          const calculatedPage = Math.floor(offset / DEFAULT_PAGE_SIZE);

          const isFilterActive = Boolean(
            currentFilters.search || currentFilters.status || currentFilters.date_from || currentFilters.date_to ||
            currentFilters.doctor_id || currentFilters.room_id || currentFilters.visit_type ||
            currentFilters.treatment_type || Object.keys(params.filterModel || {}).length
          );
          const today = getLocalDateString();

          // Extract sortModel from Ag-Grid params (set when user clicks a column header)
          let sortColumn = '';
          let sortOrder = isFilterActive ? 'desc' : 'asc';
          if (params.sortModel && params.sortModel.length > 0) {
            const sortEntry = params.sortModel[0];
            sortColumn = sortEntry.colId;
            sortOrder = sortEntry.sort; // 'asc' or 'desc'
          }

          const apiParams = {
            search: currentFilters.search,
            status: currentFilters.status,
            doctor_id: currentFilters.doctor_id,
            room_id: currentFilters.room_id,
            visit_type: currentFilters.visit_type,
            treatment_type: currentFilters.treatment_type,
            date_from: isFilterActive ? currentFilters.date_from : today,
            date_to: currentFilters.date_to,
            sort_order: sortOrder,
            sort_column: sortColumn,
            offset,
            limit,
            main: params.filterModel?.main?.filter,
            ipopnumber: params.filterModel?.ipopnumber?.filter,
            patient_name: params.filterModel?.patient_name?.filter,
            doctor_name: params.filterModel?.doctor_name?.filter,
            booking_time: params.filterModel?.created_at?.filter,
            room_number: params.filterModel?.room_number?.filter,
            booking_date: params.filterModel?.start_date?.filter,
            column_status: params.filterModel?.status?.filter,
          };

          const response = await bookingplanService.getBookingPlans(apiParams);
          const raw = Array.isArray(response?.data)
            ? response.data
            : Array.isArray(response)
            ? response
            : response?.data?.data || response?.data?.rows || [];

          const finalRows = raw.filter((item) => item && typeof item === 'object');
          const apiTotal = Number(
            response?.total ??
            response?.total_records ??
            response?.data?.total ??
            response?.data?.total_records ??
            response?.data?.totalRecords ??
            response?.totalRecords
          );

          const total = Number.isFinite(apiTotal) ? apiTotal : finalRows.length;

          // Sync React tracking states for your bottom text indicators
          setTotalRecords(total);
          setCurrentPage(calculatedPage);
          currentPageRef.current = calculatedPage;

          // Send data and total page boundary size directly to Ag-Grid internal mechanism
          params.successCallback(finalRows, total);
        } catch (err) {
          console.error(err);
          toast.error('Failed to load booking plans');
          params.failCallback();
        } finally {
          setLoading(false);
        }
      }
    };

    api.setDatasource(datasource);
  }, []);

  // Automatically recreates and re-applies the datasource from page 0 whenever filters change
  useEffect(() => {
    if (gridApiRef.current) {
      updateDatasource(gridApiRef.current, appliedFilters);
    }
  }, [appliedFilters, updateDatasource]);

  const fetchDoctorsAndRooms = async () => {
    try {
      setLoadingDropdowns(true);
      const [roomResult, doctorResult, counsellorResult] = await Promise.allSettled([
        roomServices.getRoomList(),
        doctorServices.getDoctorListByType('doctor'),
        doctorServices.getDoctorListByType('counsellor'),
      ]);

      let roomResponse = null;
      if (roomResult.status === 'fulfilled') {
        roomResponse = roomResult.value;
        console.log('[BookingPlans] Room API raw response:', roomResponse);
      } else {
        console.warn('roomServices.getRoomList failed:', roomResult.reason);
      }

      // Combine doctors and counsellors
      let doctorList = [];
      
      if (doctorResult.status === 'fulfilled' && doctorResult.value) {
        const doctors = normalizeApiList(doctorResult.value);
        console.log('[BookingPlans] Doctors loaded:', doctors.length);
        doctorList = [...doctorList, ...doctors];
      } else {
        console.warn('Failed to load doctors:', doctorResult.reason);
      }

      if (counsellorResult.status === 'fulfilled' && counsellorResult.value) {
        const counsellors = normalizeApiList(counsellorResult.value);
        console.log('[BookingPlans] Counsellors loaded:', counsellors.length);
        doctorList = [...doctorList, ...counsellors];
      } else {
        console.warn('Failed to load counsellors:', counsellorResult.reason);
      }

      // Remove duplicates based on personId
      const uniqueDoctors = doctorList.filter((doc, index, self) =>
        index === self.findIndex((d) => d.personId === doc.personId)
      );

      const roomList = normalizeApiList(roomResponse);

      console.log('[BookingPlans] Total unique doctors/counsellors:', uniqueDoctors.length, uniqueDoctors[0] ?? 'empty');
      console.log('[BookingPlans] Normalized rooms:', roomList.length, roomList[0] ?? 'empty');

      setDoctors(Array.isArray(uniqueDoctors) ? uniqueDoctors : []);
      setRooms(Array.isArray(roomList) ? roomList : []);
    } catch (err) {
      console.error('Dropdown fetch error:', err);
    } finally {
      setLoadingDropdowns(false);
    }
  };

  const getDoctorLookupId = (doctor) => {
    if (!doctor) return '';
    return doctor.id || doctor.doctor_id || doctor.doctorId || doctor.personId || doctor.gvid || doctor.gvId || '';
  };

  const findDoctorById = (id) => {
    if (!id) return null;
    return doctors.find((d) => String(getDoctorLookupId(d)) === String(id)) || null;
  };

  const getDoctorNameFromPlan = (plan) => {
    const id = plan.doctor_id || plan.doctorId || plan.counselor || plan.counselorId;
    const doctor = findDoctorById(id);
    if (doctor) return getDoctorDisplayName(doctor);
    return plan.doctor_name || plan.counselor_name || 'Unassigned';
  };

  const getDoctorDepartmentFromPlan = (plan) => {
    const id = plan.doctor_id || plan.doctorId || plan.counselor || plan.counselorId;
    const doctor = findDoctorById(id);
    return doctor?.department || plan.type || plan.specialization || plan.doctor_type || 'No department';
  };

  const getDoctorDepartmentFromPlan2 = (plan) => {
    const doctor = findDoctorById(plan.doctor_id2);
    return doctor?.department || plan.specialization2 || plan.doctor_type2 || 'No department';
  };

  const getBookingRowHeight = (row) => {
    if (!row) return 100;

    // All entry lines (package/oil/therapist/notes) are single-line, ellipsis-truncated,
    // so the row only needs to grow when a second (numbered) entry is present.
    const hasSecondaryDetails = Boolean(
      row.doctor_name2 ||
      row.doctor_identifier2 ||
      row.package_name2 ||
      row.package_service_name2 ||
      row.treatment_name2 ||
      row.medicine_oil2 ||
      row.notes2
    );

    return hasSecondaryDetails ? 148 : 96;
  };

  const multiLineCellStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    paddingTop: 10,
    paddingBottom: 10,
    boxSizing: 'border-box',
    overflow: 'hidden',
  };

  // Single-line, ellipsis-truncated text block shared by the numbered-entry
  // columns so long values clip inside their cell instead of overflowing
  // into neighbouring columns/rows.
  const truncatedLineStyle = {
    display: 'block',
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    boxSizing: 'border-box',
  };

  // -- Small numbered-badge renderer shared by the Treatment / Oil / Therapist /
  // Notes columns: shows plain content when there's only one entry, or a
  // numbered "1"/"2" list with a divider when a second-treatment value exists.
  const NumberBadge = ({ n }) => (
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: 16, height: 16, borderRadius: '50%', flexShrink: 0,
      background: '#dbeafe', color: '#1d4ed8', fontSize: 10, fontWeight: 700,
    }}>
      {n}
    </span>
  );

  const renderNumberedEntries = (entries, renderContent) => {
    const valid = entries.filter(Boolean);
    if (valid.length === 0) return <span style={{ color: '#94a3b8' }}>-</span>;
    if (valid.length === 1) return renderContent(valid[0]);
    return (
      <div style={{ width: '100%', minWidth: 0 }}> 
        {valid.map((item, idx) => (
          <React.Fragment key={idx}>
            {idx > 0 && <div style={{ borderTop: '1px dashed #e2e8f0', margin: '6px 0' }} />}
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 6,minWidth:0, width: '100%' }}>
              <NumberBadge n={idx + 1} />
              <div style={{ flex: 1, minWidth: 0 }}>{renderContent(item)}</div>
            </div>
          </React.Fragment>
        ))}
      </div>
    );
  };

  const handleOpenBoardModal = (row) => {
    setBoardModal({
      open: true,
      id: row.id,
      code: row.booking_code,
      patientName: row.patient_name,
      patientId: row.patient_id,
      visitId: row.visit_id,
      startDate: row.start_date || null,
    });
  };

  const handleOpenCompleteModal = (row) => {
    setCompleteModal({ open: true, id: row.id, code: row.booking_code, patientName: row.patient_name });
  };

  const handleOpenStartModal = (row) => {
    setStartModal({ open: true, id: row.id, patientName: row.patient_name });
  };

  const handleOpenCancelModal = (row) => {
    setCancelModal({ open: true, id: row.id, code: row.booking_code, patientName: row.patient_name });
  };

  const handleModalSuccess = (bookingId = null, patientId = null, visitId = null) => {
    // Refresh the grid after status change
    if (gridApiRef.current) {
      gridApiRef.current.refreshInfiniteCache();
    }
    
    // Navigate to patient page with refresh flag if patientId and visitId are provided (e.g., after boarding)
    if (patientId && visitId) {
      // Navigate to patient sections with refresh flag to trigger data refresh
      history.push({
        pathname: `/PatientSections/${patientId}/${visitId}`,
        state: { 
          refreshRoom: Date.now(), // This triggers the useEffect in PatientSections
          from: 'booking',
          returnTo: '/booking-plans'
        }
      });
      
      console.log('[BookingPlans] Navigating to patient page with refresh flag');
    }
  };

  const handleChangeBookingStatus = async (id, status) => {
    try {
      setLoading(true);
      await bookingplanService.updateBookingPlanStatus(id, status);
      toast.success(`✅ Booking marked as ${status}`);
      
      // Clears block row cache and updates current visual grid page view seamlessly
      if (gridApiRef.current) {
        gridApiRef.current.refreshInfiniteCache();
      }
    } catch (err) {
      console.error(err);
      toast.error('Unable to update booking status');
    } finally {
      setLoading(false);
    }
  };

  const handleEditNavigation = (id) => {
    history.push(`/booking/new-session/${id}`);
  };

  // Editing a booking plan is only allowed until 10 PM on the day it was
  // created/booked (row.created_at) — after that the edit option is locked.
  const isEditWindowOpen = (row) => {
    if (!row?.created_at) return true;
    const createdAt = new Date(`${row.start_date}T${row.start_time || '00:00:00'}`);
    if (isNaN(createdAt.getTime())) return true;
    const cutoff = new Date(createdAt);
    cutoff.setHours(22, 0, 0, 0);
    return new Date() <= cutoff;
  };

  const setFilter = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const clearFilters = () => {
    setFilters({ search: '', status: '', date_from: '', date_to: '', doctor_id: '', room_id: '', visit_type: '', treatment_type: '' });
    gridApiRef.current?.setFilterModel(null);
  };

  const hasFilters = Boolean(
    filters.search || filters.status || filters.date_from || filters.date_to || filters.doctor_id || filters.room_id || filters.visit_type || filters.treatment_type
  );
  const hasAnyFilters = hasFilters || columnFiltersActive;

  const goToNextBookingPage = useCallback(() => {
    const api = gridApiRef.current;
    if (!api) return;

    const current = typeof api.paginationGetCurrentPage === 'function'
      ? api.paginationGetCurrentPage()
      : currentPageRef.current;
    const total = typeof api.paginationGetTotalPages === 'function'
      ? api.paginationGetTotalPages()
      : totalPages;

    if (total <= 1) {
      if (typeof api.paginationGoToFirstPage === 'function') {
        api.paginationGoToFirstPage();
      }
      return;
    }

    if (current >= total - 1) {
      api.paginationGoToFirstPage();
      return;
    }

    api.paginationGoToNextPage();
  }, [totalPages]);

  useEffect(() => {
    if (!shouldAutoAdvance) return undefined;

    setAutoAdvanceStartedAt(Date.now());
    const interval = setInterval(() => {
      setAutoAdvanceStartedAt(Date.now());
      goToNextBookingPage();
    }, AUTO_ADVANCE_MS);

    return () => clearInterval(interval);
  }, [shouldAutoAdvance, goToNextBookingPage]);
//  const BOOKING_PLAN_POLL_MS = 60000;
 const BOOKING_PLAN_POLL_MS = 300000; // 5 minutes

  // Non-admin viewers don't get a manual refresh control, so periodically
  // re-fetch from the API to surface booking plans created by other sessions.
  useEffect(() => {
    if (canManageBooking) return undefined;

    const interval = setInterval(() => {
      if (gridApiRef.current) {
        updateDatasource(gridApiRef.current, appliedFilters);
      }
    }, BOOKING_PLAN_POLL_MS);

    return () => clearInterval(interval);
  }, [canManageBooking, appliedFilters, updateDatasource]);


  const columnDefs = [
    // -- Hidden columns (not part of the requested column order) ---------
    // Kept here, commented out, in case they need to be restored later.
    /*
    {
      field: 'main',
      headerName: 'MAIN',
      cellClass: ['ag-cell-center'],
      headerClass: 'ag-header-left',
      minWidth: 120,
      flex: 0.8,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        return row.patient_id
          ? <span style={{ fontWeight: 600, color: '#0f172a' }}>{row.patient_id}</span>
          : <span style={{ color: '#94a3b8' }}>-</span>;
      },
    },
    {
      field: 'ipopnumber',
      headerName: 'IP / OP No.',
      cellClass: ['ag-cell-center'],
      headerClass: 'ag-header-left',
      minWidth: 130,
      flex: 0.8,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        if (!row.ipopnumber) return <span style={{ color: '#94a3b8' }}>-</span>;
        return (
          <div style={{ lineHeight: '1.4', padding: '4px 0' }}>
            <div style={{ fontWeight: 600, color: '#0f172a' }}>{row.ipopnumber}</div>
            <div style={{ fontSize: 12, color: '#64748b' }}>{row.visit_type || '-'}</div>
          </div>
        );
      },
    },
    {
      field: 'patient_id',
      headerName: 'Patient ID',
      cellClass: ['ag-cell-center'],
      headerClass: 'ag-header-left',
      minWidth: 150,
      flex: 1,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        const hasMain = row.patient_id;
        const hasIop = row.ipopnumber;
        if (!hasMain && !hasIop) return <span style={{ color: '#94a3b8' }}>-</span>;
        return (
          <div style={{ lineHeight: '1.4', padding: '4px 0' }}>
            {hasMain && (
              <div style={{ fontSize: 11, color: '#64748b' }}>
                ID: {row.patient_id}
              </div>
            )}
            {hasIop && (
              <div style={{ fontWeight: 600, color: '#0f172a' }}>
                {row.ipopnumber}
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: 'created_at',
      headerName: 'Booking Time',
      cellClass: ['ag-cell-center'],
      headerClass: 'ag-header-left',
      minWidth: 160,
      flex: 1,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        if (!row.created_at) return <span style={{ color: '#94a3b8' }}>-</span>;
        return (
          <div style={{ padding: '4px 0', lineHeight: '1.4' }}>
            <div style={{ fontWeight: 500, fontSize: 13 }}>{formatDateTime12h(row.created_at)}</div>
          </div>
        );
      },
    },
    {
      field: 'start_date',
      headerName: 'Date / Time',
      cellClass: ['ag-cell-center'],
      headerClass: 'ag-header-left',
      minWidth: 180,
      flex: 1.2,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        return (
          <div style={{ padding: '4px 0', lineHeight: '1.4' }}>
            <div style={{ fontWeight: 600, color: '#0f172a' }}>{row.start_date || '-'}</div>
            <div style={{ fontSize: 12, color: '#64748b' }}>
              {row.start_time ? formatTime12h(row.start_time) : '--'} to {row.end_time ? formatTime12h(row.end_time) : '--'}
            </div>
          </div>
        );
      },
    },
    {
      field: 'visit_id',
      headerName: 'Visit ID',
      cellClass: ['ag-cell-center'],
      headerClass: 'ag-header-left',
      minWidth: 100,
      flex: 0.7,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        const visitId = row.visit_id;
        if (visitId) {
          return (
            <span style={{ fontWeight: 600, color: '#2563eb', fontFamily: 'monospace' }}>
              {visitId}
            </span>
          );
        }
        return <span style={{ color: '#94a3b8' }}>-</span>;
      }
    },
    */

    // -- 1. Session Start Time � End Time ---------------------
    {
      field: 'schedule',
      headerName: 'Session Schedule',
      cellClass: ['ag-cell-center'],
      headerClass: 'ag-header-left',
      cellStyle: multiLineCellStyle,
      minWidth: 190,
      flex: 1.2,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        const hasDate = row.start_date;
        const hasTime = row.start_time || row.end_time;

        if (!hasDate && !hasTime) {
          return <span style={{ color: '#94a3b8' }}>-</span>;
        }

        return (
          <div style={{ padding: '4px 0', lineHeight: '1.4', width: '100%', minWidth: 0 }}>
            {hasTime && (
              <div style={{ ...truncatedLineStyle, fontWeight: 600, fontSize: 14, color: '#11161c' }}>
                {row.start_time ? formatTime12h(row.start_time) : '--'} to {row.end_time ? formatTime12h(row.end_time) : '--'}
              </div>
            )}
            {hasDate && (
              <div style={{ ...truncatedLineStyle, fontWeight: 500, fontSize: 12, color: '#475569' }}>{row.start_date}</div>
            )}
          </div>
        );
      },
    },

    // -- 2. Patient Name ----------------------------------------
    {
      field: 'patient_name',
      headerName: 'Patient Name',
      cellClass: ['ag-cell-center'],
      headerClass: 'ag-header-left',
      cellStyle: multiLineCellStyle,
      minWidth: 150,
      flex: 1.2,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '4px 0' }}>
            <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', color: '#475569', flexShrink: 0 }}>
              {(row.patient_name || 'P').charAt(0)}
            </div>
            <div style={{ lineHeight: '1.4', minWidth: 0, flex: 1 }}>
              <div
                title={row.patient_name || 'No Patient'}
                style={{ ...truncatedLineStyle, fontWeight: 600, color: '#0f172a' }}
              >
                {row.patient_name || 'No Patient'}
              </div>
              <div style={{ ...truncatedLineStyle, fontSize: 16, color: '#171b21' }}>
                {/* {row.patient_code ? <span>ID: {row.patient_code}</span> : null} */}
                {canManageBooking && !row.patient_code && row.phone ? <span>📞 {row.phone}</span> : null}
              </div>
            </div>
          </div>
        );
      }
    },

    // -- 3. Treatment / Services --------------------------------
    {
      field: 'package_name',
      headerName: 'Treatment / Services',
      cellClass: ['ag-cell-center'],
      headerClass: 'ag-header-left',
      cellStyle: multiLineCellStyle,
      minWidth: 210,
      flex: 1.4,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;

        // Some services are not linked to a package (package_id is NULL). In
        // that case show the saved service instead of "General Treatment".
        const packageLabel =
          row.package_name ||
          row.package_service_name ||
          row.treatment_name ||
          'Individual treatment';
        const serviceLabel =
          row.package_name && row.package_service_name
            ? row.package_service_name
            : null;

        const packageLabel2 = row.package_name2 || row.package_service_name2 || row.treatment_name2 || null;
        const serviceLabel2 =
          row.package_name2 && row.package_service_name2
            ? row.package_service_name2
            : null;

        const entries = [
          { label: packageLabel, sub: serviceLabel },
          packageLabel2 ? { label: packageLabel2, sub: serviceLabel2 } : null,
        ];

        return (
          <div style={{ padding: '4px 0', lineHeight: '1.35', width: '100%', minWidth: 0 }}>
            {renderNumberedEntries(entries, (item) => (
              <>
                <div
                  title={item.sub ? `${item.label} - ${item.sub}` : item.label}
                  style={{ ...truncatedLineStyle, fontWeight: 600, color: '#0f172a' }}
                >
                  {item.label}
                </div>
                {item.sub && (
                  <div style={{ ...truncatedLineStyle, fontSize: 12, color: '#64748b' }}>
                    {item.sub}
                  </div>
                )}
              </>
            ))}
          </div>
        );
      },
    },

    // -- 4. Session Details (e.g., 1/2) -------------------------
    // {
    //   field: 'session_details',
    //   headerName: 'Session Details',
    //   cellClass: ['ag-cell-center'],
    //   headerClass: 'ag-header-left',
    //   minWidth: 130,
    //   flex: 0.8,
    //   cellRendererFramework: (params) => {
    //     const row = params.data;
    //     if (!row) return null;

    //     const currentSession = Number(row.session_number) || 1;
    //     const totalSessions = Number(row.total_sessions) || Number(row.total_days) || 1;
    //     const aggregateCompleted = Number(row.completed_sessions) || 0;
    //     const currentRowCompleted = String(row.status || '').trim().toLowerCase() === 'completed';

    //     // A completed current session must never appear as incomplete when an
    //     // older or cached API response does not include the aggregate count.
    //     const completedSessions = Math.min(
    //       Math.max(aggregateCompleted, currentRowCompleted ? currentSession : 0),
    //       totalSessions
    //     );

    //     return (
    //       <div style={{ padding: '4px 0', lineHeight: '1.35' }}>
    //         <div style={{ color: '#1d4ed8', fontWeight: 600, fontSize: 13 }}>
    //           {currentSession}/{totalSessions}
    //         </div>
    //         {/* <div style={{ fontSize: 11, color: completedSessions === totalSessions ? '#15803d' : '#64748b' }}> */}
    //          <Badge variant={statusVariant(row.status)}>{row.status || 'Scheduled'}</Badge>
    //         {/* </div> */}
    //       </div>
    //     );
    //   },
    // },
    {
  field: 'session_details',
  headerName: 'Session Details',
  cellClass: ['ag-cell-center'],
  headerClass: 'ag-header-left',
  cellStyle: multiLineCellStyle,
  minWidth: 130,
  flex: 0.8,
  cellRendererFramework: (params) => {
    const row = params.data;
    if (!row) return null;

    const currentSession = Number(row.session_number) || 1;
    const totalSessions = Number(row.total_sessions) || Number(row.total_days) || 1;
    const totalSessions2 = Number(row.total_sessions2) || Number(row.total_days2) || 0;
    const currentSession2 = Number(row.session_number2) || 1;
    const sessionEntries = [
      { current: currentSession, total: totalSessions },
      totalSessions2 > 0 ? { current: currentSession2, total: totalSessions2 } : null,
    ];
    const status = String(row.status || 'Scheduled').trim();

    // Status -> color map (fallback to slate/grey for unknown statuses)
    const statusColors = {
      scheduled: { bg: '#ecfdf5', text: '#15803d', dot: '#22c55e' },
      boarded:   { bg: '#f1f5f9', text: '#475569', dot: '#94a3b8' },
      completed: { bg: '#eff6ff', text: '#1d4ed8', dot: '#3b82f6' },
      cancelled: { bg: '#fef2f2', text: '#b91c1c', dot: '#ef4444' },
      modified: { bg: '#fff7ed', text: '#c2410c', dot: '#f97316' },
      'in progress': { bg: '#fffbeb', text: '#b45309', dot: '#f59e0b' },
    };
    const colors = statusColors[status.toLowerCase()] || {
      bg: '#f8fafc', text: '#334155', dot: '#94a3b8',
    };

    return (
      <div style={{
        padding: '6px 0',
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        alignItems: 'flex-start',
        textAlign: 'left',
        width: '100%',
         minWidth: 0,          // ? ADD THIS � this container is a flex child of the ag-grid cell
    overflow: 'hidden',   // ? ADD THIS
      }}>
        {renderNumberedEntries(sessionEntries, (item) => (
          <span style={{ color: '#1d4ed8', fontWeight: 700, fontSize: 13,
           ...truncatedLineStyle,}}>
            {item.current}/{item.total}
          </span>
        ))}

        <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 5,
          padding: '2px 10px',
          borderRadius: 999,
          fontSize: 11,
          fontWeight: 600,
          background: colors.bg,
          color: colors.text,
          lineHeight: '18px',
        }}>
          <span style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: colors.dot,
            display: 'inline-block',
          }} />
          {status}
        </span>
      </div>
    );
  },
},

    // -- 5. Medicine / Oil ---------------------------------------
    {
      field: 'medicine_oil',
      headerName: 'Medicine / Oil',
      editable: (params) => !['Completed', 'Cancelled', 'Modified'].includes(params.data?.status),
      cellClass: ['ag-cell-center'],
      headerClass: 'ag-header-left',
      cellStyle: multiLineCellStyle,
      minWidth: 150,
      flex: 0.9,
      cellRendererFramework: (params) => {
        const row = params.data;
        const entries = [
          params.value ? { label: params.value } : null,
          row?.medicine_oil2 ? { label: row.medicine_oil2 } : null,
        ];
        return (
          <div style={{ lineHeight: '1.4', width: '100%', minWidth: 0 }}>
            {renderNumberedEntries(entries, (item) => (
              <span title={item.label} style={{ ...truncatedLineStyle, fontWeight: 500, color: '#0f172a' }}>{item.label}</span>
            ))}
          </div>
        );
      },
    },

    // -- 6. Therapist --------------------------------------------
    {
      field: 'doctor_name',
      headerName: 'Therapist',
      cellClass: ['ag-cell-center'],
      headerClass: 'ag-header-left',
      cellStyle: multiLineCellStyle,
      minWidth: 220,
      flex: 1.5,
      filter: true,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        const doctorName2 = row.doctor_name2 || row.doctor_identifier2;
        const entries = [
          row.doctor_name ? { label: row.doctor_name, sub: getDoctorDepartmentFromPlan(row) } : null,
          doctorName2 ? { label: doctorName2, sub: getDoctorDepartmentFromPlan2(row) } : null,
        ];
        return (
          <div style={{ padding: '4px 0', lineHeight: '1.4', width: '100%', minWidth: 0 }}>
            {renderNumberedEntries(entries, (item) => (
              <>
                <div title={item.label} style={{ ...truncatedLineStyle, fontWeight: 600, color: '#0f172a' }}>{item.label}</div>
                <div title={item.sub} style={{ ...truncatedLineStyle, fontSize: 12, color: '#64748b' }}>{item.sub}</div>
              </>
            ))}
          </div>
        );
      },
    },

    // -- 7. Special Instructions ---------------------------------
    {
      field: 'notes',
      headerName: 'Special Instructions',
      editable: (params) => !['Completed', 'Cancelled', 'Modified'].includes(params.data?.status),
      cellClass: ['ag-cell-center'],
      headerClass: 'ag-header-left',
      cellStyle: multiLineCellStyle,
      minWidth: 180,
      flex: 1,
      cellRendererFramework: (params) => {
        const entries = [
          params.value ? { label: params.value } : null,
          params.data?.notes2 ? { label: params.data.notes2 } : null,
        ];
        return (
          <div style={{ lineHeight: '1.4', width: '100%', minWidth: 0 }}>
            {renderNumberedEntries(entries, (item) => (
              <span title={item.label} style={{ ...truncatedLineStyle, fontWeight: 500, color: '#0f172a' }}>
                {item.label}
              </span>
            ))}
          </div>
        );
      },
    },

    // -- 8. Room --------------------------------------------------
    {
      field: 'room_number',
      headerName: 'Room',
      cellClass: ['ag-cell-center'],
      headerClass: 'ag-header-left',
      cellStyle: multiLineCellStyle,
      minWidth: 180,
      flex: 1,
      filter: true,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        const code = row.room_code || row.roomcode || '';
        const name = row.room_number || row.room_name || row.roomname || '';
        const label = code && name ? `${code} - ${name}` : code || name || '-';
        return (
          <span title={label} style={{ ...truncatedLineStyle, fontWeight: 500 }}>
            {label}
          </span>
        );
      },
    },

    // -- 9. Status ------------------------------------------------
    // {
    //   field: 'status',
    //   headerName: 'Status',
    //   cellClass: ['ag-cell-center'],
    //   headerClass: 'ag-header-left',
    //   minWidth: 130,
    //   flex: 0.8,
    //   cellRendererFramework: (params) => {
    //     const row = params.data;
    //     if (!row) return null;
    //     return <Badge variant={statusVariant(row.status)}>{row.status || 'Scheduled'}</Badge>;
    //   }
    // },

    // -- Actions (kept, not part of the numbered list, needed for row actions) --
    {
      headerName: 'Actions',
      field: 'actions',
      cellClass: ['ag-cell-center'],
      headerClass: 'ag-header-left',
      hide: !canManageBooking,
      sortable: false,
      filter: false,
      floatingFilter: false,
      minWidth: 280,
      flex: 1.5,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;

        const status = String(row.status || 'Scheduled').trim().toLowerCase();
        const isCancelled = status === 'cancelled';
        const isModified = status === 'modified';

        const isCompleted = status === 'completed';
        const isBoarded = status === 'boarded';
        const isScheduled = status === 'scheduled';
        const isInProgress = status === 'in progress';
        // A "Modified" row was superseded by a reassign (new booking created in
        // its place) — treat it as terminal just like Cancelled/Completed so its
        // dead row no longer offers Edit/Board/Cancel actions.
        const isTerminal = isCancelled || isCompleted || isModified;
        const hasVisitId = Boolean(row.visit_id);
        const editWindowOpen = isEditWindowOpen(row);

        return (
          <div style={{ display: 'flex', gap: 4, alignItems: 'center', height: '100%', flexWrap: 'wrap' }}>
            {/* Edit button - visible unless terminal; disabled after 10 PM on the booking's created day */}
            {!isTerminal && (
              <Button
                variant="ghost"
                size="icon"
                title={editWindowOpen ? 'Edit Booking' : 'Editing is locked after 10 PM on the day this booking was made'}
                disabled={!editWindowOpen}
                onClick={() => editWindowOpen && handleEditNavigation(row.id)}
              >
                <Edit2 size={16} />
              </Button>
            )}

            {/* Board Patient button - only before boarding (no visit_id, not terminal) */}
            {!hasVisitId && !isTerminal && isScheduled && (
              <Button
                variant="ghost"
                size="icon"
                title="Board Patient"
                onClick={() => handleOpenBoardModal(row)}
                style={{ color: '#2563eb' }}
              >
                <LogIn size={16} />
              </Button>
            )}

            {/* Start Session is available after boarding, including attached upcoming sessions. */}
            {hasVisitId && !isTerminal && (isBoarded || isScheduled) && (
              <Button
                variant="ghost"
                size="icon"
                title="Start Session"
                onClick={() => handleOpenStartModal(row)}
                style={{ color: '#d97706' }}
              >
                <PlayCircle size={16} />
              </Button>
            )}

            {/* Complete is available only after the session has started. */}
            {hasVisitId && !isTerminal && isInProgress && (
              <Button
                variant="ghost"
                size="icon"
                title="Mark Complete"
                onClick={() => handleOpenCompleteModal(row)}
                style={{ color: '#16a34a' }}
              >
                <CheckCircle size={16} />
              </Button>
            )}

            {/* Completed badge */}
            {isCompleted && (
              <span style={{
                fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 999,
                background: '#dcfce7', color: '#166534',
              }}>
                ✓ Completed
              </span>
            )}

            {/* Cancelled badge */}
            {isCancelled && (
              <span style={{
                fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 999,
                background: '#fef2f2', color: '#991b1b',
              }}>
                 ✕ Cancelled
              </span>
            )}

            {/* Modified badge */}
            {isModified && (
              <span style={{
                fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 999,
                background: '#fff7ed', color: '#c2410c',
              }}>
                ✎ Modified
              </span>
            )}

            {/* Cancel button - only for non-terminal bookings */}
            {!isTerminal && (
              <Button variant="ghost" size="icon" title="Cancel Booking" onClick={() => handleOpenCancelModal(row)}>
                <XCircle size={16} color="#dc2626" />
              </Button>
            )}
          </div>
        );
      },
    },
  ];

  const onGridReady = useCallback((params) => {
    gridApiRef.current = params.api;
    updateDatasource(params.api, appliedFilters);
  }, [appliedFilters, updateDatasource]);

  return (
    <div className="page-container fade-in">
      {/* Modals */}
      {boardModal.open && (
        <BoardPatientModal
          bookingId={boardModal.id}
          bookingCode={boardModal.code}
          patientName={boardModal.patientName}
          patientId={boardModal.patientId}
          visitId={boardModal.visitId}
          bookingStartDate={boardModal.startDate}
          onClose={() => setBoardModal({ open: false, id: null, code: null, patientName: null, patientId: null, visitId: null, startDate: null })}
          onSuccess={(bookingId, newVisitId) => handleModalSuccess(bookingId, boardModal.patientId, newVisitId)}
        />
      )}
      {startModal.open && (
        <StartSessionModal
          bookingId={startModal.id}
          patientName={startModal.patientName}
          onClose={() => setStartModal({ open: false, id: null, patientName: null })}
          onSuccess={handleModalSuccess}
        />
      )}
      {completeModal.open && (
        <CompleteBookingModal
          bookingId={completeModal.id}
          bookingCode={completeModal.code}
          patientName={completeModal.patientName}
          onClose={() => setCompleteModal({ open: false, id: null, code: null, patientName: null })}
          onSuccess={handleModalSuccess}
        />
      )}
      {cancelModal.open && (
        <CancelBookingModal
          bookingId={cancelModal.id}
          bookingCode={cancelModal.code}
          patientName={cancelModal.patientName}
          onClose={() => setCancelModal({ open: false, id: null, code: null, patientName: null })}
          onSuccess={handleModalSuccess}
        />
      )}

      {/* Header Bar */}
      {showSearchAndFilters && (
        <div className="booking-page-header">
          <div className="booking-page-search">
            <Search size={18} />
            <input
              type="text"
              placeholder="Search Patients By Name / PhoneNumber / MAIN / Aadhaar Number..."
              value={filters.search}
              onChange={(e) => setFilter('search', e.target.value)}
            />
          </div>
          <div className="booking-page-actions">
            <Button variant={showFilters ? 'primary' : 'ghost'} size="icon" onClick={() => setShowFilters(!showFilters)}>
              <Filter size={18} />
            </Button>
            {canManageBooking && (
              <Button onClick={() => history.push('/booking/new-session', { from: 'booking' })}>
                <Plus size={18} /> New Booking
              </Button>
            )}
          </div>
        </div>
      )}

      {/* Title */}
      <div className="booking-page-title-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <h2 style={{ margin: 0 }}>Booking Plans</h2>
          {!hasAnyFilters && (
            <span style={{
              fontSize: 12, fontWeight: 700, padding: '3px 10px', borderRadius: 999,
              background: '#dbeafe', color: '#1e40af',
            }}>
              📅 Today & Upcoming
            </span>
          )}
          {hasAnyFilters && (
            <span style={{
              fontSize: 12, fontWeight: 700, padding: '3px 10px', borderRadius: 999,
              background: '#fef3c7', color: '#92400e',
            }}>
              🔍 Filtered (all records)
            </span>
          )}
        </div>
      </div>

      {/* Row colour legend */}
      <div style={{ display: 'flex', gap: 16, marginBottom: 12, fontSize: 12, flexWrap: 'wrap' }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <span style={{ width: 12, height: 12, background: '#fef2f2', border: '2px solid #f87171', borderRadius: 2, display: 'inline-block' }} />
          No doctor & no room assigned
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <span style={{ width: 12, height: 12, background: '#fffbeb', border: '2px solid #fbbf24', borderRadius: 2, display: 'inline-block' }} />
          Partially assigned (doctor or room missing)
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <span style={{ width: 12, height: 12, background: '#fff', border: '2px solid #86efac', borderRadius: 2, display: 'inline-block' }} />
          Fully assigned
        </span>
      </div>

      {/* Advanced Filtering Panel */}
      {showSearchAndFilters && showFilters && (
        <div className="ui-card filter-panel" style={{ marginBottom: 20, padding: '15px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '28px' }}>
            <div style={{ display: 'flex', gap: '32px', flexWrap: 'wrap' }}>
              <div className="filter-group">
                <label className="filter-label">Status</label>
                <select className="form-control" value={filters.status} onChange={(e) => setFilter('status', e.target.value)}>
                  <option value="">All Status</option>
                  <option value="Scheduled">Scheduled</option>
                  <option value="Boarded">Boarded</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Completed">Completed</option>
                  <option value="Cancelled">Cancelled</option>
                  
                </select>
              </div>
              <div className="filter-group">
                <label className="filter-label">Doctor</label>
                <select className="form-control" value={filters.doctor_id} onChange={(e) => setFilter('doctor_id', e.target.value)} disabled={loadingDropdowns}>
                  <option value="">{loadingDropdowns ? 'Loading doctors...' : 'All Doctors'}</option>
                  {doctors.length > 0 && doctors.map((d) => (
                    <option key={getDoctorLookupId(d) || Math.random()} value={getDoctorLookupId(d)}>
                      {getDoctorDisplayName(d)}
                    </option>
                  ))}
                </select>
                {!loadingDropdowns && doctors.length === 0 && (
                  <div style={{ fontSize: 11, color: '#dc2626', marginTop: 4 }}>No doctors available</div>
                )}
              </div>
              <div className="filter-group" style={{ minWidth: 170 }}>
                <label className="filter-label">From Date</label>
                <input type="date" className="form-control" value={filters.date_from} onChange={(e) => setFilter('date_from', e.target.value)} />
              </div>
              <div className="filter-group" style={{ minWidth: 170 }}>
                <label className="filter-label">To Date</label>
                <input type="date" className="form-control" value={filters.date_to} onChange={(e) => setFilter('date_to', e.target.value)} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '32px', flexWrap: 'wrap' }}>
              <div className="filter-group">
                <label className="filter-label">Visit Type</label>
                <select className="form-control" value={filters.visit_type} onChange={(e) => setFilter('visit_type', e.target.value)}>
                  <option value="">All Visit Types</option>
                  <option value="InPatient">Inpatient</option>
                  <option value="OutPatient">Outpatient</option>
                  <option value="Walkin">Walk-in</option>
                </select>
              </div>
              <div className="filter-group">
                <label className="filter-label">Treatment Type</label>
                <select className="form-control" value={filters.treatment_type} onChange={(e) => setFilter('treatment_type', e.target.value)}>
                  <option value="">All Treatments</option>
                  <option value="General">General Treatment</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="filter-group">
                <label className="filter-label">Room</label>
                <select className="form-control" value={filters.room_id} onChange={(e) => setFilter('room_id', e.target.value)} disabled={loadingDropdowns}>
                  <option value="">{loadingDropdowns ? 'Loading rooms...' : 'All Rooms'}</option>
                  {rooms.length > 0 && rooms.map((r) => {
                    const roomId = getRoomLookupId(r);
                    return (
                      <option key={roomId || Math.random()} value={roomId}>
                        {getRoomDisplayName(r)}
                      </option>
                    );
                  })}
                </select>
                {!loadingDropdowns && rooms.length === 0 && (
                  <div style={{ fontSize: 11, color: '#dc2626', marginTop: 4 }}>No rooms available</div>
                )}
              </div>
              <Button type="button" variant="secondary" onClick={clearFilters} disabled={!hasAnyFilters} style={{ alignSelf: 'flex-end', marginLeft: 'auto', marginRight:'200px'}}>
                Clear Filters
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Active filter indicator */}
      {showSearchAndFilters && hasAnyFilters && (
        <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 13, color: '#64748b', fontWeight: 500 }}>
            Active filters applied
          </span>
          <span className="ui-badge ui-badge-blue" style={{ fontSize: 11, padding: '3px 10px' }}>
            {[
              filters.status && 'Status',
              filters.visit_type && 'Visit Type',
              filters.treatment_type && 'Treatment Type',
              filters.doctor_id && 'Doctor',
              filters.room_id && 'Room',
              (filters.date_from || filters.date_to) && 'Date Range',
              filters.search && 'Search',
              columnFiltersActive && 'Column filters',
            ].filter(Boolean).join(', ')}
          </span>
        </div>
      )}

      {/* Grid with automated infinite scrolling / server side pagination */}
      <div className="p-3 preview">
        <div className="ag-theme-balham style card rounded" style={{ fontSize: "14px", height: 630, width: "100%" }}>
          <AgGridReact
            ref={gridRef}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            
            // Core Native Pagination Settings
            rowModelType="infinite"
            cacheBlockSize={DEFAULT_PAGE_SIZE}
            pagination={true}
            paginationPageSize={DEFAULT_PAGE_SIZE}
            onGridReady={onGridReady}
            onFilterChanged={(event) => {
              setColumnFiltersActive(Object.keys(event.api.getFilterModel() || {}).length > 0);
            }}
            rowHeight={100

            }
            getRowHeight={(params) => {
              return getBookingRowHeight(params.data);
            }}
            getRowStyle={(params) => {
              if (!params.data) return undefined;
              const cls = getRowClass(params.data);
              if (cls === 'row-unassigned') return { background: '#fef2f2', borderLeft: '3px solid #f87171' };
              if (cls === 'row-partial') return { background: '#fffbeb', borderLeft: '3px solid #fbbf24' };
              return { background: 'white' };
            }}
            overlayNoRowsTemplate={`<span style="color:#6b7280;padding:20px;display:block">No booking plans found</span>`}
          />
        </div>
        {/* Total matching records indicator synced directly to current interactive page layout */}
        <div style={{ marginTop: 12, fontSize: 13, color: '#64748b' }}>
          {/* Showing <b>{startRecord}</b> to <b>{endRecord}</b> of <b>{totalRecords}</b> matching records */}
        </div>
      </div>

      <AutoAdvanceCountdown
        active={shouldAutoAdvance}
        durationMs={AUTO_ADVANCE_MS}
        startedAt={autoAdvanceStartedAt}
      />
    </div>
  );
}
